// Helper function to disable all checkout buttons
function disableCheckout() {
  const checkoutButtonIds = ['hero-cta-checkout-button', 'cdp-cart-checkout-btn'];
  
  checkoutButtonIds.forEach(buttonId => {
    const button = document.getElementById(buttonId);
    if (button) {
      button.disabled = true;
    }
  });
  
  // Also disable buttons with class hero-cta-button (fallback)
  const heroButtons = document.querySelectorAll('.hero-cta-button');
  heroButtons.forEach(button => {
    button.disabled = true;
  });
}

// Helper function to enable all checkout buttons
function enableCheckout() {
  const checkoutButtonIds = ['hero-cta-checkout-button', 'cdp-cart-checkout-btn'];
  
  checkoutButtonIds.forEach(buttonId => {
    const button = document.getElementById(buttonId);
    if (button) {
      button.disabled = false;
     
    }
  });
  
  // Also enable buttons with class hero-cta-button (fallback)
  const heroButtons = document.querySelectorAll('.hero-cta-button');
  heroButtons.forEach(button => {
    button.disabled = false;
    
  });
}

// Helper function to fetch cart with retry logic
async function fetchCartWithRetry(options = {}, maxRetries = 3, retryDelay = 1000) {
  const defaultOptions = {
    credentials: 'same-origin',
    headers: { 'Accept': 'application/json' }
  };
  
  const fetchOptions = { ...defaultOptions, ...options };
  
  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      const response = await fetch('/cart.js', fetchOptions);
      
      if (!response.ok) {
        // If it's a 500 error and we have retries left, retry
        if (response.status >= 500 && attempt < maxRetries) {
          console.warn(`⚠️ Cart fetch failed with status ${response.status}, retrying... (attempt ${attempt}/${maxRetries})`);
          await new Promise(resolve => setTimeout(resolve, retryDelay * attempt)); // Exponential backoff
          continue;
        }
        // If it's not a 500 error or we're out of retries, throw
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      
      return await response.json();
    } catch (error) {
      // If it's the last attempt, throw the error
      if (attempt === maxRetries) {
        console.error(`❌ Cart fetch failed after ${maxRetries} attempts:`, error);
        throw error;
      }
      
      // Otherwise, wait and retry
      console.warn(`⚠️ Cart fetch error (attempt ${attempt}/${maxRetries}), retrying...`, error.message);
      await new Promise(resolve => setTimeout(resolve, retryDelay * attempt));
    }
  }
}



function updateCartIconVisibility() {
  const cartIconBubble = document.getElementById('cart-icon-bubble');
  const supplements = window.currentSupplementCart;

  const itemCount = Object.keys(supplements).length;

  if (cartIconBubble) {
      // If the cart icon bubble exists, update the count
      const countElements = cartIconBubble.querySelectorAll('.cart-count-bubble span');
      const cartCountBubble = cartIconBubble.querySelector('.cart-count-bubble');
      countElements.forEach(element => {
          element.textContent = itemCount;
      });
      cartCountBubble.style.display = itemCount > 0 ? 'flex' : 'none';
  } else {
      // If the cart icon bubble does not exist, create it
      const cartIconHTML = `
          <a href="/cart" class="header__icon header__icon--cart link focus-inset" id="cart-icon-bubble" style="display: ${itemCount > 0 ? 'flex' : 'none'};">
              <svg class="icon icon-cart" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 40 40" fill="none">
                  <path fill="currentColor" fill-rule="evenodd" d="M20.5 6.5a4.75 4.75 0 00-4.75 4.75v.56h-3.16l-.77 11.6a5 5 0 004.99 5.34h7.38a5 5 0 004.99-5.33l-.77-11.6h-3.16v-.57A4.75 4.75 0 0020.5 6.5zm3.75 5.31v-.56a3.75 3.75 0 10-7.5 0v.56h7.5zm-7.5 1h7.5v.56a3.75 3.75 0 11-7.5 0v-.56zm-1 0v.56a4.75 4.75 0 109.5 0v-.56h2.22l.71 10.67a4 4 0 01-3.99 4.27h-7.38a4 4 0 01-4-4.27l.72-10.67h2.22z"></path>
              </svg>
              <span class="visually-hidden">Cart</span>
              <div class="cart-count-bubble">
                  <span aria-hidden="true">${itemCount}</span>
                  <span class="visually-hidden">${itemCount} items</span>
              </div>
          </a>
      `;
      const header = document.querySelector('.header'); // Adjust this selector based on your actual HTML structure
      if (header) {
          header.insertAdjacentHTML('beforeend', cartIconHTML);
      }
  }
}





// Global function to add a supplement to cart
async function globalAddSupplementToCart(
    supplementName,
    buttonElement = null,
    AddingText = "Adding...",
    AddedText = "Added to Stack",
      eventName = 'AddToCart',
      shouldOpenCart = true
) {
      // Disable checkout buttons at the start
      disableCheckout();
      
    try {
      // --- 1. Use provided card or load from localStorage
      // --- 2. Get variant ID
      const variantId = fetchDataSupplement[supplementName]?.variantId;
      if (!variantId) throw new Error(`No variantId found for ${supplementName}`);
    
      // --- 3. Mutate the object (updates caller’s variable if provided)
        window.currentSupplementCart[supplementName] = [supplementName, [], [], false, variantId];
    
      // --- 4. Save updated cart and update metafield
      await saveCurrentSupplementCart();
    
        // --- 12. Trigger cart change event for grid listeners
        console.log('📢 Dispatching cartChanged event from globalAddSupplementToCart');
        window.dispatchEvent(new CustomEvent('cartChanged', {
          detail: {
            eventName: eventName,
            supplementName: supplementName,
            action: 'add',
            functionName: 'globalAddSupplementToCart'
          }
        }));
        
        // --- 13. Trigger delayed cart change event
        setTimeout(() => {
          console.log('📢 Dispatching cartChangedDelayed event from globalAddSupplementToCart');
          window.dispatchEvent(new CustomEvent('cartChangedDelayed', {
            detail: {
              eventName: eventName,
              supplementName: supplementName,
              action: 'add',
              functionName: 'globalAddSupplementToCart'
            }
          }));
        }, 1000);
    
        // --- 5. Open cart drawer if requested
        if (shouldOpenCart ) {
          openCart(true); // Open with delay for smooth UX
        } else {
        
         console.log('openCart function not found', shouldOpenCart);
        }
        
        // --- 6. Update button (if provided)
      if (buttonElement) {
        buttonElement.textContent = AddingText;
        buttonElement.disabled = true;
      }
    
      // --- 6. Add to Shopify cart
      const formData = new FormData();
      formData.append("id", parseInt(variantId, 10));
      formData.append("quantity", 1);
      formData.append("selling_plan", "6827213091"); // 1-month plan
    
      const response = await fetch("/cart/add.js", {
        method: "POST",
        body: formData,
      });
    
      if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);
    
      const result = await response.json();
      console.log("✅ Item added to cart:", result);
    
      // --- 7. Set final button state
      if (buttonElement) {
        buttonElement.textContent = AddedText;
          buttonElement.disabled = false;
      }
    
      // --- 8. Currency code handling
      let currencyCode = "SGD"; // default
      if (window.Shopify?.currency?.active) {
        currencyCode = Shopify.currency.active;
      }
    
      // --- 9. Price lookup
      let price = priceSupplementsConverted[supplementName]?.DEFAULT || 0;
      if (
        priceSupplementsConverted[supplementName] &&
        priceSupplementsConverted[supplementName][currencyCode]
      ) {
        price = priceSupplementsConverted[supplementName][currencyCode];
      }
    
      // --- 10. Tracking
      
      // trackWithFbqAndCAPI(eventName, {
      //   content_type: "product",
      //   content_ids: [String(variantId)],
      //   contents: [
      //     {
      //       id: String(variantId),
      //       quantity: 1,
      //       item_price: price,
      //     },
      //   ],
      //   value: price,
      //   currency: currencyCode,
      //   product_title: supplementName,
      // });

       trackGoogle(eventName, {
        content_type: "product",
        content_ids: [String(variantId)],
        contents: [
          {
            id: String(variantId),
            quantity: 1,
            item_price: price,
          },
        ],
        value: price,
        currency: currencyCode,
        product_title: supplementName,
      });
    
      if (!sessionStorage.getItem('uniqueAddToCartTracked')) {
          //trackWithFbqAndCAPI("uniqueAddToCart");
          sessionStorage.setItem("uniqueAddToCartTracked", "true");
      }
      
      //--- 11. Update cart supplement tags based on current cart state
      try {
        const customerEmail = localStorage.getItem('customerEmail');
        if (customerEmail) {
          // Get all supplements in current cart
          const supplementsInCart = Object.keys(window.currentSupplementCart);
          
          // Create tags for all supplements in cart with cart_supplement_ prefix
          const cartSupplementTags = supplementsInCart.map(name => 
            `cart_supplement_${name.toLowerCase().replace(/\s+/g, '_')}`
          );
          
          console.log('📝 Updating cart supplement tags:', cartSupplementTags);
          
          // Add cart supplement tags and cart_added tag using globalAddTags
          const allTags = [...cartSupplementTags, "cart_added"];
          globalAddTags(allTags).catch(err => {
            console.warn('⚠️ Failed to add cart tags (non-blocking):', err);
          });
        }
      } catch (error) {
        console.warn('⚠️ Error updating cart supplement tags:', error);
      }
    
        // --- 12. Re-enable checkout buttons
      enableCheckout();
    
    } catch (error) {
      console.error("❌ Error adding to cart:", error);
    
      if (buttonElement) {
        buttonElement.textContent = "Add to Stack";
        buttonElement.disabled = false;
      }
    
        // Re-enable checkout buttons on error
        enableCheckout();
    
      return null;
    }
  }




// Global function to add a box (stack) to cart
async function globalAddBoxToCart(
    boxName,
    buttonElement = null,
    AddingText = "Adding...",
    AddedText = "Added to Stack",
    All_in_stack = "All Items in Stack",
      eventName = "AddBoxToCart",
      shouldOpenCart = true
) {
        // Disable checkout buttons at the start
        disableCheckout();
        
    try {
        // --- 1. Handle special case for "Your Protocol"
        let boxSupplementsList;
        let normalizedBoxName;
        let variantIdForTracking;
        
        if (boxName === "Your Protocol") {
        // Get supplements from currentRecommendations in localStorage
        const currentRecommendationsStr = localStorage.getItem('recommendation');
        if (!currentRecommendationsStr) {
            throw new Error('❌ No current recommendations found in localStorage');
        }
        
        const currentRecommendations = JSON.parse(currentRecommendationsStr);
        const supplementNames = Object.keys(currentRecommendations);
        
        // Convert supplement names to supplement objects with name property
        boxSupplementsList = supplementNames.map(name => ({ name: name }));
        normalizedBoxName = "Your Protocol";
        variantIdForTracking = "yourStackRecommendation";
        } else {
        // --- 2. Normalize boxName for regular boxes
        const boxVariantId = {
            Energy: "54223239872803",
            Sleep: "54219497898275",
            Fitness: "54223237218595",
            "The Energy Protocol": "54223239872803",
            "The Sleep Protocol": "54219497898275",
            "The Fitness Protocol": "54223237218595",
        };

        const boxMapping = {
            Energy: "The Energy Protocol",
            Sleep: "The Sleep Protocol",
            Fitness: "The Fitness Protocol",
            "The Energy Protocol": "The Energy Protocol",
            "The Sleep Protocol": "The Sleep Protocol",
            "The Fitness Protocol": "The Fitness Protocol",
        };

        if (!boxVariantId[boxName]) {
            throw new Error(`❌ Invalid boxName: ${boxName}`);
        }

        normalizedBoxName = boxMapping[boxName]; // always use long form
        boxSupplementsList = boxSupplements[normalizedBoxName] || boxSupplements[boxName];
        variantIdForTracking = boxVariantId[boxName];
        }


        // --- 3. Set button loading state
        if (buttonElement) {
        buttonElement.textContent = AddingText;
        buttonElement.disabled = true;
        }

        // --- 4. First, add all supplements to window.currentSupplementCart and collect supplements to add
        const supplementsToAdd = [];
        
        // Process all supplements in the box - ensure loop completes fully
        for (const supplement of boxSupplementsList) {
            const supplementName = supplement.name;

            // Skip if already in cart
            if (window.currentSupplementCart[supplementName]) {
            console.log(`${supplementName} already in cart, skipping...`);
            continue;
            }

            const variantId = fetchDataSupplement[supplementName]?.variantId;
            if (!variantId) {
            console.error(`No variantId for ${supplementName}`);
            continue;
            }

            // Update currentSupplementCart immediately
            window.currentSupplementCart[supplementName] = [supplementName, [], [], false, variantId];
            
            // Add to list of supplements to add to actual cart
            supplementsToAdd.push({
            name: supplementName,
            variantId: variantId
            });
            
            console.log(`✅ Added ${supplementName} to window.currentSupplementCart`);
        }
        
        // --- 5. Save updated cart to localStorage (only after loop completes)
        console.log(`💾 Saving cart to localStorage with ${supplementsToAdd.length} new supplements`);
        await saveCurrentSupplementCart();

        // --- 13. Trigger cart change event for grid listeners
        console.log('📢 Dispatching cartChanged event from globalAddBoxToCart');
        window.dispatchEvent(new CustomEvent('cartChanged', {
            detail: {
            eventName: eventName,
            boxName: boxName,
            normalizedBoxName: normalizedBoxName,
            supplementsAdded: supplementsToAdd.map(s => s.name),
            action: 'addBox',
            functionName: 'globalAddBoxToCart'
            }
        }));
        
        // --- 14. Trigger delayed cart change event
        setTimeout(() => {
            console.log('📢 Dispatching cartChangedDelayed event from globalAddBoxToCart');
            window.dispatchEvent(new CustomEvent('cartChangedDelayed', {
            detail: {
                eventName: eventName,
                boxName: boxName,
                normalizedBoxName: normalizedBoxName,
                supplementsAdded: supplementsToAdd.map(s => s.name),
                action: 'addBox',
                functionName: 'globalAddBoxToCart'
            }
            }));
        }, 1000);

        if (shouldOpenCart ) {
            openCart(true); // Open with delay for smooth UX
        } else {
        
            console.log('openCart function not found', shouldOpenCart);
        }


        // --- 7. Add supplements to actual Shopify cart after cart is opened
        let addedCount = 0;
        for (const supplement of supplementsToAdd) {
            try {
            const formData = new FormData();
            formData.append("id", parseInt(supplement.variantId, 10));
            formData.append("quantity", 1);
            formData.append("selling_plan", "6827213091");

            const response = await fetch("/cart/add.js", {
            method: "POST",
            body: formData,
            });

            if (!response.ok) throw new Error(`HTTP error! status: ${response.status}`);

            const result = await response.json();
            console.log(`✅ Added ${supplement.name} to Shopify cart:`, result);
            addedCount++;
        } catch (error) {
            console.error(`❌ Error adding ${supplement.name} to Shopify cart:`, error);
            // Remove from currentSupplementCart if failed to add to Shopify cart
            delete window.currentSupplementCart[supplement.name];
        }
        }

        // --- 8. Update localStorage again if any supplements failed to add
        await saveCurrentSupplementCart();

        // --- 9. Currency & price
        let currencyCode = "SGD";
        if (window.Shopify?.currency?.active) {
        currencyCode = Shopify.currency.active;
        }

        let price = 0;
        
        if (normalizedBoxName === "Your Protocol") {
        // Calculate price by summing individual supplement prices
        const currentRecommendationsStr = localStorage.getItem('currentRecommendations');
        if (currentRecommendationsStr) {
            const currentRecommendations = JSON.parse(currentRecommendationsStr);
            const supplementNames = Object.keys(currentRecommendations);
            
            supplementNames.forEach(supplementName => {
            if (typeof priceSupplementsConverted !== 'undefined' && priceSupplementsConverted[supplementName]) {
                const supplementPrice = priceSupplementsConverted[supplementName][currencyCode] || 
                                        priceSupplementsConverted[supplementName].DEFAULT || 0;
                price += supplementPrice;
            }
            });
        }
        } else {
        // Use priceBoxes for regular boxes
        price = priceBoxes[normalizedBoxName]?.DEFAULT || 0;
        if (priceBoxes[normalizedBoxName] && priceBoxes[normalizedBoxName][currencyCode]) {
            price = priceBoxes[normalizedBoxName][currencyCode];
        }
        }

        // --- 10. Tracking event (box-level)
        if (addedCount > 0) {
        // trackWithFbqAndCAPI(eventName, {
        //     content_type: "product",
        //     content_ids: [String(variantIdForTracking)],
        //     contents: [
        //     {
        //         id: String(variantIdForTracking),
        //         quantity: 1,
        //         item_price: price,
        //     },
        //     ],
        //     value: price,
        //     currency: currencyCode,
        //     product_title: normalizedBoxName,
        // });

        trackGoogle(eventName, {
            content_type: "product",
            content_ids: [String(variantIdForTracking)],
            contents: [
            {
                id: String(variantIdForTracking),
                quantity: 1,
                item_price: price,
            },
            ],
            value: price,
            currency: currencyCode,
            product_title: normalizedBoxName,
        });


        }

        // --- 11. Update button final state
        if (buttonElement) {
        if (addedCount > 0) {
            buttonElement.textContent = AddedText;
        } else {
            buttonElement.textContent = All_in_stack;
        }
            buttonElement.disabled = false;
        }

        if (!sessionStorage.getItem('uniqueAddToCartTracked')) {
            //trackWithFbqAndCAPI("uniqueAddToCart");
            sessionStorage.setItem("uniqueAddToCartTracked", "true");
        }
        
        // --- 12. Update cart supplement tags based on current cart state
        try {
            // Get all supplements in current cart
            const supplementsInCart = Object.keys(window.currentSupplementCart);
            
            // Create tags for all supplements in cart with cart_supplement_ prefix
            const cartSupplementTags = supplementsInCart.map(name => 
              `cart_supplement_${name.toLowerCase().replace(/\s+/g, '_')}`
            );
            
            console.log('📝 Updating cart supplement tags:', cartSupplementTags);
            
            // Add special tags based on box type
            const specialTags = ["cart_added"];
            
            if (normalizedBoxName === "Your Protocol") {
              specialTags.push("cart_recommendation_added");
            } else if (normalizedBoxName === "The Sleep Protocol") {
              specialTags.push("cart_sleep_stack_added");
            } else if (normalizedBoxName === "The Fitness Protocol") {
              specialTags.push("cart_fitness_stack_added");
            }
            
            // Combine cart supplement tags and special tags
            const allTags = [...cartSupplementTags, ...specialTags];
            globalAddTags(allTags).catch(err => {
              console.warn('⚠️ Failed to add cart tags (non-blocking):', err);
            });
          
        } catch (error) {
          console.warn('⚠️ Error updating cart supplement tags:', error);
        }


        // --- 13. Re-enable checkout buttons
        enableCheckout();

    } catch (error) {
        console.error("❌ Error adding box to cart:", error);

        if (buttonElement) {
        buttonElement.textContent = "Add to Stack";
        buttonElement.disabled = false;
        }

        // Re-enable checkout buttons on error
        enableCheckout();

        return null;
    }
}

async function globalRemoveSupplementFromCart(
  supplementName,
  buttonElement = null,
  RemovingText = "Removing...",
  RemovedText = "Removed from Stack",
    eventName = "RemoveFromCart"
) {
    // Disable checkout buttons at the start
    disableCheckout();
    
  try {
    // --- 1. Use provided cart or load from localStorage

    // --- 2. Get variant ID
    const variantId = fetchDataSupplement[supplementName]?.variantId;
    if (!variantId) throw new Error(`No variantId found for ${supplementName}`);

    // --- 3. Remove from the cart object (updates caller's variable if provided)
      delete window.currentSupplementCart[supplementName];

    // --- 4. Save updated cart and update metafield
      await saveCurrentSupplementCart();
  
      // --- 14. Trigger cart change event for grid listeners
      console.log('📢 Dispatching cartChanged event from globalRemoveSupplementFromCart');
      window.dispatchEvent(new CustomEvent('cartChanged', {
        detail: {
          eventName: eventName,
          supplementName: supplementName,
          action: 'remove',
          functionName: 'globalRemoveSupplementFromCart'
        }
      }));
      
      // --- 15. Trigger delayed cart change event
      setTimeout(() => {
        console.log('📢 Dispatching cartChangedDelayed event from globalRemoveSupplementFromCart');
        window.dispatchEvent(new CustomEvent('cartChangedDelayed', {
          detail: {
            eventName: eventName,
            supplementName: supplementName,
            action: 'remove',
            functionName: 'globalRemoveSupplementFromCart'
          }
        }));
      }, 1000);

    // --- 5. Update button (if provided)
    if (buttonElement) {
      buttonElement.textContent = RemovingText;
      buttonElement.disabled = true;
    }
  

    // --- 6. Get current cart to find the item to remove (with retry logic)
    const currentCart = await fetchCartWithRetry();

    // --- 7. Find the cart item by variant ID
    const cartItem = currentCart.items.find(item => 
      item.variant_id.toString() === variantId.toString()
    );

    if (!cartItem) {
      console.log(`Item ${supplementName} not found in cart`);
      // Still update button state even if item wasn't in cart
      if (buttonElement) {
        buttonElement.textContent = RemovedText;
        buttonElement.disabled = true;
      }
        enableCheckout();
        return window.currentSupplementCart;
    }

    // --- 8. Remove from Shopify cart
    const removeResponse = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        id: cartItem.key,
        quantity: 0
      })
    });

    if (!removeResponse.ok) throw new Error(`HTTP error! status: ${removeResponse.status}`);

    const result = await removeResponse.json();
    console.log("✅ Item removed from cart:", result);

    // --- 9. Set final button state
    if (buttonElement) {
      buttonElement.textContent = RemovedText;
      buttonElement.disabled = true;
    }

    // --- 10. Update cart supplement tags based on current cart state
    try {
      const customerEmail = localStorage.getItem('customerEmail');
      if (customerEmail) {
        // Get all supplements in current cart
        const supplementsInCart = Object.keys(window.currentSupplementCart);
        
        // Only update if there are supplements remaining in cart
        if (supplementsInCart.length > 0) {
          // Create tags for all supplements in cart with cart_supplement_ prefix
          const cartSupplementTags = supplementsInCart.map(name => 
            `cart_supplement_${name.toLowerCase().replace(/\s+/g, '_')}`
          );
          
          console.log('📝 Updating cart supplement tags after removal:', cartSupplementTags);
          
          // Add cart supplement tags using globalAddTags
          globalAddTags(cartSupplementTags).catch(err => {
            console.warn('⚠️ Failed to add cart tags (non-blocking):', err);
          });
        } else {
          console.log('📝 Cart is empty, skipping cart supplement tags update');
        }
      }
    } catch (error) {
      console.warn('⚠️ Error updating cart supplement tags:', error);
    }

   

      // --- 13. Re-enable checkout buttons
      enableCheckout();
  
      // --- 15. Return updated cart (optional use for chaining)
      return window.currentSupplementCart;
  } catch (error) {
    console.error("❌ Error removing from cart:", error);

    if (buttonElement) {
      buttonElement.textContent = "Remove from Stack";
      buttonElement.disabled = false;
    }
  
      // Re-enable checkout buttons on error
      enableCheckout();

    return null;
  }
}




/*

async function removeBoxAndApp() {
  // Disable checkout buttons at the start
  disableCheckout();
  
try {
  const variantIdBox = "53559051747619";
  const variantIdApp = "53559300587811";
  
  console.log("Removing Box and App items from cart...");
  
  // Get current cart contents
  const cartResponse = await fetch('/cart.js');
  if (!cartResponse.ok) {
    throw new Error(`HTTP error! status: ${cartResponse.status}`);
  }
  const currentCart = await cartResponse.json();
  
  // Find items to remove
  const itemsToRemove = currentCart.items.filter(item => 
    item.variant_id.toString() === variantIdBox || 
    item.variant_id.toString() === variantIdApp
  );
  
  if (itemsToRemove.length === 0) {
      enableCheckout();
    console.log("No Box or App items found in cart");
    return;
  }
  
  console.log(`Found ${itemsToRemove.length} Box/App items to remove:`, itemsToRemove);
  
  // Remove each item
  for (const item of itemsToRemove) {
    try {
      const removeResponse = await fetch('/cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          id: item.key,
          quantity: 0
        })
      });

      if (!removeResponse.ok) {
        throw new Error(`HTTP error! status: ${removeResponse.status}`);
      }

      const result = await removeResponse.json();
      console.log(`✅ Removed ${item.product_title} (${item.variant_id}) from cart:`, result);
    } catch (error) {
      console.error(`Failed to remove ${item.product_title} (${item.variant_id}) from cart:`, error);
    }
  }
  
  // Update cart icon visibility
  
  console.log("Box and App removal completed");
  
    // Re-enable checkout buttons
    enableCheckout();
  
} catch (error) {
  console.error("❌ Error removing Box and App items:", error);
    
    // Re-enable checkout buttons on error
    enableCheckout();
  }
}

*/


async function removeBoxAndApp() {
  disableCheckout();
  const VARIANT_IDS_TO_ZERO = ["53559051747619", "53559300587811"];

  // helper: safe JSON or text
  const safeParse = async (res) => {
    const ct = res.headers.get('content-type') || '';
    if (ct.includes('application/json')) return res.json();
    const txt = await res.text();
    return { _raw: txt };
  };

  try {
    // Quick existence check to avoid a write if not needed (with retry logic)
    const cart = await fetchCartWithRetry({ credentials: 'same-origin', headers: { 'Accept': 'application/json' } });

    const hasTargets = cart.items.some(i => VARIANT_IDS_TO_ZERO.includes(String(i.variant_id)));
    if (!hasTargets) { enableCheckout(); return; }

    // Build updates map: { variant_id: 0, ... }
    const updates = {};
    VARIANT_IDS_TO_ZERO.forEach(id => { updates[id] = 0; });

    // Single batched update
    const res = await fetch('/cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ updates })
    });

    const reqId = res.headers.get('x-request-id'); // keep if we need support
    if (!res.ok) {
      const body = await safeParse(res);
      console.error('Cart update failed', res.status, { reqId, body });
      // Retry once after refreshing cart (handles race/stale state)
      const refRes = await fetch('/cart.js', { credentials: 'same-origin', headers: { 'Accept': 'application/json' } });
      const fresh = refRes.ok ? await refRes.json() : null;
      // Fallback: remove by key for any remaining targets
      if (fresh) {
        for (const it of fresh.items) {
          if (VARIANT_IDS_TO_ZERO.includes(String(it.variant_id))) {
            const r = await fetch('/cart/change.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              body: JSON.stringify({ id: it.key, quantity: 0 })
            });
            const rid = r.headers.get('x-request-id');
            if (!r.ok) {
              const b = await safeParse(r);
              console.error('Fallback remove failed', r.status, { rid, item: it, body: b });
            }
          }
        }
      }
    } else {
      const data = await safeParse(res);
      console.log('Cart update ok', { reqId, data });
    }
  } catch (err) {
    console.error('❌ Error in removeBoxAndApp()', err);
  } finally {
    enableCheckout();
  }
}





// Global function to check and apply discount codes (element-agnostic)
async function globalAddDiscount(
  discountCode,
  buttonElement = null,
  CheckingText = "Checking...",
  AppliedText = "Discount Applied",
  InvalidText = "Invalid Code",
  AlreadyAppliedText = "Already Applied"
) {
  // Disable checkout buttons at the start
  disableCheckout();
  
  try {
    // --- 1. Validate input
    if (!discountCode || typeof discountCode !== 'string') {
      throw new Error('Invalid discount code provided');
    }

    // Clean the discount code (trim whitespace only, preserve case)
    const cleanCode = discountCode.trim();
    
    console.log(cleanCode)
    if (cleanCode.length === 0) {
      throw new Error('Discount code cannot be empty');
    }

    // --- 2. Update button state (if provided)
    if (buttonElement) {
      buttonElement.textContent = CheckingText;
      buttonElement.disabled = true;
    }

    // --- 3. Check if discount is already applied in localStorage
    const appliedDiscounts = getAppliedDiscounts();
    if (appliedDiscounts[cleanCode]) {
      console.log(`Discount code ${cleanCode} is already applied`);
      
      if (buttonElement) {
        buttonElement.textContent = AlreadyAppliedText;
        buttonElement.disabled = true;
        
        // Re-enable button after showing "already applied" message
        setTimeout(() => {
          buttonElement.textContent = 'Apply';
          buttonElement.disabled = false;
        }, 2000);
      }
      
      // Re-enable checkout buttons
      enableCheckout();
      
      return {
        success: true,
        message: 'Discount code already applied',
        code: cleanCode,
        alreadyApplied: true
      };
    }

    // --- 4. Get current cart for validation
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
    }
    const currentCart = await cartResponse.json();
    
    // --- 5. Prepare cart data for validation endpoint
    const cartData = currentCart.items.map(item => ({
      product_id: item.product_id,
      variant_id: item.variant_id,
      price: item.price / 100, // Convert from cents
      quantity: item.quantity,
      title: item.title
    }));

    // --- 6. Validate discount using your endpoint with timeout
    const timeoutPromise = new Promise((_, reject) => 
      setTimeout(() => reject(new Error('TIMEOUT')), 10000)
    );

    const validationPromise = fetch('https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/validateShopifyDiscount', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        discountCode: cleanCode,
        cart: cartData
      })
    });

    let validationResponse;
    try {
      validationResponse = await Promise.race([validationPromise, timeoutPromise]);
    } catch (error) {
      if (error.message === 'TIMEOUT') {
        console.log(`⏰ Validation timeout for ${cleanCode}`);
        
        if (buttonElement) {
          buttonElement.textContent = 'Timeout';
          setTimeout(() => {
            buttonElement.textContent = 'Apply';
            buttonElement.disabled = false;
          }, 3000);
        }

        // Re-enable checkout buttons
        enableCheckout();

        return {
          success: false,
          message: 'Timeout: apply codes at checkout',
          code: cleanCode,
          error: 'TIMEOUT',
          applyAtCheckout: true
        };
      }
      throw error; // Re-throw non-timeout errors
    }

    if (!validationResponse.ok) {
      throw new Error(`Validation endpoint error: ${validationResponse.status}`);
    }

    const validationResult = await validationResponse.json();

    // --- 7. Handle validation result
    if (!validationResult.success || !validationResult.valid) {
      let errorMessage = 'Discount code is invalid';
      let buttonText = InvalidText;
      
      // Handle specific error types
      if (validationResult.reason === 'invalid_code') {
        errorMessage = 'This discount code is invalid or does not exist';
        buttonText = 'Invalid Code';
      } else if (validationResult.reason === 'expired') {
        errorMessage = 'This discount code has expired';
        buttonText = 'Expired';
      } else if (validationResult.reason === 'usage_limit_exceeded') {
        errorMessage = 'This discount code has reached its usage limit';
        buttonText = 'Limit Reached';
      } else if (validationResult.reason === 'prerequisites_not_met') {
        errorMessage = 'Cart does not meet the requirements for this discount';
        buttonText = 'Requirements Not Met';
      } else if (validationResult.reason === 'entitlements_not_met') {
        errorMessage = 'Your cart items are not eligible for this discount';
        buttonText = 'Not Eligible';
      } else if (validationResult.message) {
        errorMessage = validationResult.message;
        buttonText = 'Cannot Apply';
      }
      
      if (buttonElement) {
        buttonElement.textContent = buttonText;
        setTimeout(() => {
          buttonElement.textContent = 'Apply';
          buttonElement.disabled = false;
        }, 3000);
      }

      // Show specific error message
      showDiscountError(errorMessage);

      // Re-enable checkout buttons
      enableCheckout();

      return {
        success: false,
        message: errorMessage,
        code: cleanCode,
        error: validationResult.reason || 'INVALID_CODE'
      };
    }

    // --- 8. Process valid discount based on type
    const discount = validationResult.discount;
    
    console.log('line item disocunt cart', discount)
    if (discount.type === 'shipping') {
      // 1. Shipping discount - apply as free shipping
      await applyShippingDiscount(cleanCode, discount);
      
      if (buttonElement) {
        buttonElement.textContent = AppliedText;
        buttonElement.disabled = false;
      }

      // Re-enable checkout buttons
      enableCheckout();

      return {
        success: true,
        message: 'Free shipping applied',
        code: cleanCode,
        discount: discount
      };
      
    } else if (discount.type === 'line_item') {
      // 2 & 3. Line item discount - handle existing discounts
      const result = await handleLineItemDiscount(cleanCode, discount);
      
      if (buttonElement) {
        if (result.success) {
          buttonElement.textContent = AppliedText;
        } else {
          buttonElement.textContent = InvalidText;
          setTimeout(() => {
            buttonElement.textContent = 'Apply';
            buttonElement.disabled = false;
          }, 2000);
        }
        buttonElement.disabled = false;
      }

      // Re-enable checkout buttons
      enableCheckout();

      return result;
    }

  } catch (error) {
    console.error("❌ Error applying discount:", error);

    // --- Reset button on error
    if (buttonElement) {
      buttonElement.textContent = 'Apply';
      buttonElement.disabled = false;
    }

    // Re-enable checkout buttons on error
    enableCheckout();

    return {
      success: false,
      message: error.message || 'Failed to apply discount code',
      error: 'SYSTEM_ERROR'
    };
  }
}

// Helper function to get applied discounts from localStorage
function getAppliedDiscounts() {
  try {
    const stored = localStorage.getItem('appliedDiscounts');
    return stored ? JSON.parse(stored) : {};
  } catch (error) {
    console.error('Error getting applied discounts:', error);
    return {};
  }
}

// Helper function to save applied discounts to localStorage
function saveAppliedDiscounts(discounts) {
  try {
    localStorage.setItem('appliedDiscounts', JSON.stringify(discounts));
  } catch (error) {
    console.error('Error saving applied discounts:', error);
  }
}

// Function to apply shipping discount
async function applyShippingDiscount(discountCode, discount) {
  try {
    const appliedDiscounts = getAppliedDiscounts();
    
    // Save shipping discount
    appliedDiscounts[discountCode] = {
      type: 'shipping',
      code: discountCode,
      title: discount.title || 'Free Shipping',
      savings: 'Free shipping'
    };
    
    saveAppliedDiscounts(appliedDiscounts);
    console.log(`✅ Shipping discount ${discountCode} applied`);
    
  } catch (error) {
    console.error('❌ Error applying shipping discount:', error);
    throw error;
  }
}

// Function to handle line item discounts with conflict resolution
async function handleLineItemDiscount(discountCode, discount) {
  try {
    const appliedDiscounts = getAppliedDiscounts();
    
    // Helper to check if a code is an "exception" code that can stack with others
    const isExceptionCode = (code) => {
      const normalizedCode = code.toUpperCase();
      console.log('is exception code', normalizedCode);

      return normalizedCode.startsWith('EXCL_') || normalizedCode === 'OJEGV-10' || normalizedCode === 'CNY2026';
    };
    
    // Check if the new code is an exception code - if so, always apply (can stack)
    if (isExceptionCode(discountCode)) {
      appliedDiscounts[discountCode] = {
        type: 'line_item',
        code: discountCode,
        title: discount.title || discountCode,
        value: discount.value,
        valueType: discount.valueType,
        savings: discount.savings
      };
      
      saveAppliedDiscounts(appliedDiscounts);
      console.log(`✅ Exception discount ${discountCode} applied (stacks with other codes)`);
      
      return {
        success: true,
        message: 'Discount code applied successfully',
        code: discountCode,
        discount: discount
      };
    }
    
    // Check for existing line item discounts (excluding shipping AND exception codes)
    const existingLineItemDiscounts = Object.values(appliedDiscounts).filter(d => 
      d.type === 'line_item' && !isExceptionCode(d.code)
    );
    
    if (existingLineItemDiscounts.length === 0) {
      // 2. No existing non-exception discount - simply apply the new one
      appliedDiscounts[discountCode] = {
        type: 'line_item',
        code: discountCode,
        title: discount.title || discountCode,
        value: discount.value,
        valueType: discount.valueType,
        savings: discount.savings
      };
      
      saveAppliedDiscounts(appliedDiscounts);
      console.log(`✅ Line item discount ${discountCode} applied`);
      
      return {
        success: true,
        message: 'Discount code applied successfully',
        code: discountCode,
        discount: discount
      };
      
    } else {
      // 3. Existing non-exception discount exists - compare savings
      const existingDiscount = existingLineItemDiscounts[0];
      const currentSavings = calculateDiscountSavings(existingDiscount);
      const newSavings = discount.savings;
      
      if (newSavings > currentSavings) {
        // New discount is better - remove old and apply new
        const oldCode = existingDiscount.code;
        
        // Remove old discount from localStorage first
        delete appliedDiscounts[oldCode];
        
        // Remove old discount from display immediately
        const oldDiscountElement = document.querySelector(`[data-discount-code="${oldCode}"]`);
        if (oldDiscountElement) {
          oldDiscountElement.remove();
          console.log(`🗑️ Removed old discount element for ${oldCode} from display`);
        } else {
          console.warn(`⚠️ Could not find old discount element for ${oldCode}`);
        }
        
        // Add new discount to localStorage
        appliedDiscounts[discountCode] = {
          type: 'line_item',
          code: discountCode,
          title: discount.title || discountCode,
          value: discount.value,
          valueType: discount.valueType,
          savings: discount.savings
        };
        
        saveAppliedDiscounts(appliedDiscounts);
        console.log(`✅ Better discount ${discountCode} applied, removed ${oldCode}`);
        
        // Force refresh of applied discounts display to ensure consistency
        setTimeout(() => {
          displayAppliedDiscountsFromStorage();
        }, 100);
        
        return {
          success: true,
          message: `Better discount applied! Replaced ${oldCode}`,
          code: discountCode,
          discount: discount,
          replaced: oldCode
        };
        
      } else {
        // Current discount is better or equal
        console.log(`❌ Discount ${discountCode} savings (${newSavings}) not better than current (${currentSavings})`);
        
        const currentSavingsFormatted = formatWithCurrency(window.Shopify?.currency, currentSavings.toFixed(2));
        const newSavingsFormatted = formatWithCurrency(window.Shopify?.currency, newSavings.toFixed(2));
        
        return {
          success: false,
          message: `Cannot combine discounts. Current discount (${existingDiscount.code}) saves ${currentSavingsFormatted}, new discount would save ${newSavingsFormatted}`,
          code: discountCode,
          error: 'CANNOT_COMBINE'
        };
      }
    }
    
  } catch (error) {
    console.error('❌ Error handling line item discount:', error);
    throw error;
  }
}

// Global function to calculate discount savings
function calculateDiscountSavings(discount) {
  if (discount.valueType === 'fixed_amount') {
    return discount.value; // Fixed amount in SGD
  } else if (discount.valueType === 'percentage') {
    // Calculate percentage savings based on current cart
    const cartSubtotal = globalCalculateCartSubtotal();
    return cartSubtotal * (discount.value / 100);
  }
  return 0;
}

// Global function to calculate cart subtotal
function globalCalculateCartSubtotal() {
  try {
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplements = Object.keys(currentSupplementCart);
    
    let subtotal = 0;
    let currencyCode = "SGD";
    
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Calculate subtotal using supplement prices
    supplements.forEach(supplementName => {
      let price = 0;
      if (typeof priceSupplementsConverted !== 'undefined' && priceSupplementsConverted[supplementName]) {
        price = priceSupplementsConverted[supplementName][currencyCode] || priceSupplementsConverted[supplementName].DEFAULT || 0;
      } else if (typeof priceSupplements !== 'undefined' && priceSupplements[supplementName]) {
        const priceString = priceSupplements[supplementName];
        price = parseFloat(priceString.replace(/[^0-9.-]+/g, "")) || 0;
      }
      subtotal += price;
    });
    
    return subtotal;
  } catch (error) {
    console.error('Error calculating cart subtotal:', error);
    return 0;
  }
}

// Global function to calculate cart totals (element-agnostic)
function globalCalculateCartTotals() {
  try {
    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }
    
    // Calculate subtotal from supplements
    const subtotal = globalCalculateCartSubtotal();
    
    // Get applied discounts from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    
    // Calculate total discount amount
    let totalDiscountAmount = 0;
    let hasShippingDiscount = false;
    
    Object.values(appliedDiscounts).forEach(discount => {
      if (discount.type === 'line_item') {
        if (discount.valueType === 'fixed_amount') {
          totalDiscountAmount += discount.value;
        } else if (discount.valueType === 'percentage') {
          totalDiscountAmount += subtotal * (discount.value / 100);
        }
      } else if (discount.type === 'shipping') {
        hasShippingDiscount = true;
      }
    });
    
    const subtotalAfterDiscount = subtotal - totalDiscountAmount;
    
    // Calculate shipping cost (free if shipping discount applied)
    let shippingCost = 0;
    if (!hasShippingDiscount) {
      shippingCost = calculateShippingCost(subtotalAfterDiscount, currencyCode);
    }
    
    const finalTotal = subtotalAfterDiscount + shippingCost;
    
    return {
      subtotal,
      totalDiscountAmount,
      hasShippingDiscount,
      shippingCost,
      subtotalAfterDiscount,
      finalTotal,
      currencyCode
    };
    
  } catch (error) {
    console.error('❌ Error calculating cart totals:', error);
    return {
      subtotal: 0,
      totalDiscountAmount: 0,
      hasShippingDiscount: false,
      shippingCost: 0,
      subtotalAfterDiscount: 0,
      finalTotal: 0,
      currencyCode: "SGD"
    };
  }
}

// Global function to calculate shipping progress (element-agnostic)
function globalCalculateShippingProgress(currencyCode = "SGD") {
  try {
    // Calculate subtotal and discounts from localStorage
    const subtotal = globalCalculateCartSubtotal();
    const appliedDiscounts = getAppliedDiscounts();
    
    // Calculate discount amount
    let totalDiscountAmount = 0;
    let hasShippingDiscount = false;
    
    Object.values(appliedDiscounts).forEach(discount => {
      if (discount.type === 'line_item') {
        if (discount.valueType === 'fixed_amount') {
          totalDiscountAmount += discount.value;
        } else if (discount.valueType === 'percentage') {
          totalDiscountAmount += subtotal * (discount.value / 100);
        }
      } else if (discount.type === 'shipping') {
        hasShippingDiscount = true;
      }
    });
    
    const discountedSubtotal = subtotal - totalDiscountAmount;
    
    // Get shipping threshold
    const shippingConfig = {
      SGD: { threshold: 50, cost: 5.5 },
      USD: { threshold: 40, cost: 4.0 },
      EUR: { threshold: 45, cost: 4.5 },
      MYR: { threshold: 215, cost: 29 },
      GBP: { threshold: 35, cost: 3.5 },
      AUD: { threshold: 75, cost: 9.9 },
      CAD: { threshold: 55, cost: 5.5 },
      JPY: { threshold: 5000, cost: 500 },
      INR: { threshold: 3000, cost: 300 },
      CNY: { threshold: 300, cost: 30 },
      HKD: { threshold: 400, cost: 99 },
      IDR: { threshold: 1100000, cost: 299000 },
      DEFAULT: { threshold: 50, cost: 5.5 }
    };
    
    const config = shippingConfig[currencyCode] || shippingConfig.DEFAULT;
    const freeShippingThreshold = config.threshold;
    
    // Check if free shipping is achieved
    const freeShippingAchieved = hasShippingDiscount || discountedSubtotal >= freeShippingThreshold;
    
    if (freeShippingAchieved) {
      const reason = hasShippingDiscount ? 'discount applied' : 'minimum reached';
      return {
        freeShippingAchieved: true,
        progressPercentage: 100,
        message: `Free shipping (${reason})!`,
        amountNeeded: 0,
        amountNeededFormatted: formatWithCurrency(window.Shopify?.currency, '0.00')
      };
    } else {
      const progress = (discountedSubtotal / freeShippingThreshold) * 100;
      const amountNeeded = freeShippingThreshold - discountedSubtotal;
      
      return {
        freeShippingAchieved: false,
        progressPercentage: Math.min(progress, 100),
        message: '',
        amountNeeded,
        amountNeededFormatted: formatWithCurrency(window.Shopify?.currency, amountNeeded.toFixed(2))
      };
    }
    
  } catch (error) {
    console.error('❌ Error calculating shipping progress:', error);
    return {
      freeShippingAchieved: false,
      progressPercentage: 0,
      message: '',
      amountNeeded: 0,
      amountNeededFormatted: '$0.00'
    };
  }
}

// Helper function for backward compatibility
function calculateCartSubtotal() {
  return globalCalculateCartSubtotal();
}

// Global function to remove applied discount (element-agnostic)
async function globalRemoveAppliedDiscount(discountCode) {
  try {
    // Remove from localStorage
    const appliedDiscounts = getAppliedDiscounts();
    delete appliedDiscounts[discountCode];
    saveAppliedDiscounts(appliedDiscounts);
    
    console.log(`✅ Discount code ${discountCode} removed from localStorage`);
    
    return {
      success: true,
      message: 'Discount removed successfully',
      code: discountCode
    };
    
  } catch (error) {
    console.error('❌ Error removing applied discount:', error);
    return {
      success: false,
      message: error.message || 'Failed to remove discount',
      code: discountCode
    };
  }
}




/*
// Global function to go to checkout (element-agnostic)
async function globalGoToCheckout(callbacks = {}, buttonElement = null, processingText = "Redirecting...") {
  // Disable all checkout buttons at the start
  disableCheckout();
  
  try {
    const { onSuccess, onError } = callbacks;
    
    // Update button content immediately if provided
    if (buttonElement) {
      buttonElement.innerHTML = processingText;
      buttonElement.disabled = true;
    }
    
    const currentSupplementCart = JSON.parse(localStorage.getItem("currentSupplementCart")) || {};
    const supplements = Object.keys(currentSupplementCart);
    
    if (supplements.length === 0) {
      throw new Error('Cart is empty');
    }
    
    // --- 1. Sync cart contents with window.currentSupplementCart
    console.log('🔄 Syncing cart contents before checkout...');
    
    // Get current Shopify cart
    const cartResponse = await fetch('/cart.js');
    if (!cartResponse.ok) {
      throw new Error(`Failed to fetch cart: ${cartResponse.status}`);
    }
    const currentCart = await cartResponse.json();
    
    // Create sets for comparison
    const cartSupplementNames = new Set();
    const supplementCartNames = new Set(supplements);
    const cartItemsToUpdate = []; // Items that need quantity adjustment
    
    // Extract supplement names from current cart and check quantities
    currentCart.items.forEach(item => {
      // Skip box and app items
      if (item.variant_id.toString() === '53559051747619' || 
          item.variant_id.toString() === '53559300587811') {
        return;
      }
      
      // Find supplement name by variant ID
      const supplementName = Object.keys(fetchDataSupplement).find(name => 
        fetchDataSupplement[name].variantId === item.variant_id.toString()
      );
      
      if (supplementName) {
        cartSupplementNames.add(supplementName);
        
        // Check if quantity needs adjustment
        if (item.quantity !== 1) {
          cartItemsToUpdate.push({
            key: item.key,
            supplementName: supplementName,
            currentQuantity: item.quantity,
            targetQuantity: 1
          });
        }
      }
    });
    
    console.log('Cart supplements:', Array.from(cartSupplementNames));
    console.log('Window supplements:', Array.from(supplementCartNames));
    console.log('Items needing quantity update:', cartItemsToUpdate);
    
    // Remove supplements that are in cart but not in currentSupplementCart
    const supplementsToRemove = Array.from(cartSupplementNames).filter(name => 
      !supplementCartNames.has(name)
    );
    
    // Add supplements that are in currentSupplementCart but not in cart
    const supplementsToAdd = Array.from(supplementCartNames).filter(name => 
      !cartSupplementNames.has(name)
    );
    
    console.log('Supplements to remove:', supplementsToRemove);
    console.log('Supplements to add:', supplementsToAdd);
    
    // Remove unwanted supplements
    for (const supplementName of supplementsToRemove) {
      try {
        await globalRemoveSupplementFromCart(
          supplementName,
          null,
          "Removing...",
          "Removed from Stack",
          "RemoveFromCartCheckoutSync"
        );
        console.log(`✅ Removed ${supplementName} from cart`);
      } catch (error) {
        console.error(`❌ Failed to remove ${supplementName}:`, error);
      }
    }
    
    // Add missing supplements
    for (const supplementName of supplementsToAdd) {
      try {
        await globalAddSupplementToCart(
          supplementName,
          null,
          "Adding...",
          "Added to Stack",
          "AddToCartCheckoutSync",
          false // Don't open cart during checkout
        );
        console.log(`✅ Added ${supplementName} to cart`);
      } catch (error) {
        console.error(`❌ Failed to add ${supplementName}:`, error);
      }
    }
    
    // Update quantities to 1 for all items
    for (const item of cartItemsToUpdate) {
      try {
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: 1
          })
        });
        
        if (!updateResponse.ok) {
          throw new Error(`Failed to update quantity: ${updateResponse.status}`);
        }
        
        const result = await updateResponse.json();
        console.log(`✅ Updated ${item.supplementName} quantity from ${item.currentQuantity} to 1`);
      } catch (error) {
        console.error(`❌ Failed to update quantity for ${item.supplementName}:`, error);
      }
    }
    
    console.log('✅ Cart sync completed');
    
    // --- 2. Add Box and App to cart sequentially and wait for completion
    const quantity = 1;
    
    // Add Monthly Box
    const variantIdBox = '53559051747619';
    const formDataBox = new FormData();
    formDataBox.append('id', parseInt(variantIdBox, 10));
    formDataBox.append('quantity', quantity);
    formDataBox.append('properties[Contains]', '30 daily sachets');
    
    // Add App Access
    const variantIdApp = '53559300587811';
    const formDataApp = new FormData();
    formDataApp.append('id', parseInt(variantIdApp, 10));
    formDataApp.append('quantity', quantity);
    
    let boxAdded = false;
    let appAdded = false;
    
    // Add Monthly Box
    try {
      const boxResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formDataBox
      });
      
      if (!boxResponse.ok) {
        throw new Error(`Failed to add box: ${boxResponse.status}`);
      }
      
      const boxResult = await boxResponse.json();
      console.log('✅ Monthly Box added to cart:', boxResult);
      boxAdded = true;
    } catch (error) {
      console.error('❌ Error adding monthly box:', error);
      throw new Error('Failed to add monthly box to cart');
    }
    
    // Only proceed if box was successfully added
    if (!boxAdded) {
      throw new Error('Monthly box could not be added to cart');
    }
    
    // Add App Access
    try {
      const appResponse = await fetch('/cart/add.js', {
        method: 'POST',
        body: formDataApp
      });
      
      if (!appResponse.ok) {
        throw new Error(`Failed to add app: ${appResponse.status}`);
      }
      
      const appResult = await appResponse.json();
      console.log('✅ App access added to cart:', appResult);
      appAdded = true;
    } catch (error) {
      console.error('❌ Error adding app access:', error);
      throw new Error('Failed to add app access to cart');
    }
    
    // Only proceed if both items were successfully added
    if (!boxAdded || !appAdded) {
      throw new Error('Could not add all required items to cart');
    }
    
    console.log('✅ Both box and app successfully added to cart, proceeding to checkout...');
    
    // Get applied discount codes from localStorage for checkout URL
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts);
    
    // Add "initiated_checkout" tag before redirecting (non-blocking)
    try {
      console.log('📝 Adding initiated_checkout tag...');
      await globalAddTags(["initiated_checkout"]);
    } catch (error) {
      console.warn('⚠️ Failed to add initiated_checkout tag, continuing to checkout:', error);
      // Continue to checkout even if tag addition fails
    }
    
    // Call success callback before redirect
    if (onSuccess) onSuccess();
    
    // Re-enable checkout buttons before redirect
    enableCheckout();
    
    // Redirect to checkout
    if (discountCodes.length > 0) {
      const discountQuery = discountCodes.map(code => encodeURIComponent(code)).join(',');
      window.location.href = `/checkout?discount=${discountQuery}`;
    } else {
      window.location.href = '/checkout';
    }
    
    return {
      success: true,
      message: 'Redirecting to checkout...',
      discountCodes
    };
    
  } catch (error) {
    console.error('❌ Error during checkout:', error);
    
    // Reset button state on error
    if (buttonElement) {
      buttonElement.innerHTML = 'Checkout';
      buttonElement.disabled = false;
    }
    
    // Re-enable checkout buttons on error
    enableCheckout();
    
    // Call error callback
    if (callbacks.onError) {
      callbacks.onError(error);
    }
    
    return {
      success: false,
      message: error.message || 'Failed to process checkout',
      error: error
    };
  }
}


*/



// Constants for special variant IDs
const BOX_VARIANT_ID = '53559051747619';
const APP_VARIANT_ID = '53559300587811';
const DAILY_SACHETS_PRODUCT_ID = 10158050410787;
const MORNING_SACHETS_PRODUCT_ID = 10266178486563;
const MORNING_SACHETS_VARIANT_ID = 55230807245091;
const EVENING_SACHETS_PRODUCT_ID = 10266178322723;
const EVENING_SACHETS_VARIANT_ID = 55230806819107;
// Base sachet product covers the first 4 supplements; each supplement beyond
// that is one unit of the extra-supplement product (6 supplements -> qty 2).
const EXTRA_SUPPLEMENT_PRODUCT_ID = 10185948987683;
const EXTRA_SUPPLEMENT_VARIANT_ID = 54942373970211;
const PROTOCOL_BASE_SUPPLEMENT_COUNT = 4;

// The extra-supplement product has a single available subscription selling plan
// (its own selling-plan group — the box's NutricodeProtocol selling_plan_id is
// rejected with 422 for this variant). Used for the extra line on every plan.
const EXTRA_SUPPLEMENT_SELLING_PLAN_ID = '6827213091';
/** Line property for starting-protocol supplement list (FormData: properties[Contains]) */
const STARTING_PROTOCOL_CONTAINS_PROPERTY = 'Contains';

// Optional micro-optimisation: cache variantId -> supplementName
let variantIdToSupplementNameCache = null;
function getVariantIdToSupplementNameMap() {
  if (!variantIdToSupplementNameCache) {
    variantIdToSupplementNameCache = Object.entries(fetchDataSupplement).reduce(
      (acc, [name, data]) => {
        acc[data.variantId] = name;
        return acc;
      },
      {}
    );
  }
  return variantIdToSupplementNameCache;
}

function getCurrentSupplementCartFromLocalStorage() {
  try {
    const raw = localStorage.getItem("currentSupplementCart");
    return raw ? JSON.parse(raw) : {};
  } catch (e) {
    console.warn("Failed to parse currentSupplementCart from localStorage:", e);
    return {};
  }
}

async function fetchShopifyCart() {
  const res = await fetch('/cart.js');
  if (!res.ok) {
    throw new Error(`Failed to fetch cart: ${res.status}`);
  }
  return res.json();
}

// Compute which supplements to remove/add and which items need quantity updates
function analyzeCart(currentCart, currentSupplementCartKeys) {
  const variantIdToName = getVariantIdToSupplementNameMap();

  const cartSupplementNames = new Set();
  const supplementCartNames = new Set(currentSupplementCartKeys);
  const cartItemsToUpdate = [];

  for (const item of currentCart.items) {
    const variantIdStr = item.variant_id.toString();

    // Skip box and app items
    if (variantIdStr === BOX_VARIANT_ID || variantIdStr === APP_VARIANT_ID) {
      continue;
    }

    const supplementName = variantIdToName[variantIdStr];
    if (!supplementName) continue;

    cartSupplementNames.add(supplementName);

    if (item.quantity !== 1) {
      cartItemsToUpdate.push({
        key: item.key,
        supplementName,
        currentQuantity: item.quantity,
        targetQuantity: 1
      });
    }
  }

  const supplementsToRemove = Array.from(cartSupplementNames).filter(
    name => !supplementCartNames.has(name)
  );

  const supplementsToAdd = Array.from(supplementCartNames).filter(
    name => !cartSupplementNames.has(name)
  );

  console.log('Cart supplements:', Array.from(cartSupplementNames));
  console.log('Window supplements:', Array.from(supplementCartNames));
  console.log('Items needing quantity update:', cartItemsToUpdate);
  console.log('Supplements to remove:', supplementsToRemove);
  console.log('Supplements to add:', supplementsToAdd);

  return {
    supplementsToRemove,
    supplementsToAdd,
    cartItemsToUpdate
  };
}

async function syncSupplementsWithCart({ supplementsToRemove, supplementsToAdd }) {
  // Keep operations sequential to preserve behaviour and logging order

  for (const supplementName of supplementsToRemove) {
    try {
      await globalRemoveSupplementFromCart(
        supplementName,
        null,
        "Removing...",
        "Removed from Stack",
        "RemoveFromCartCheckoutSync"
      );
      console.log(`✅ Removed ${supplementName} from cart`);
    } catch (error) {
      console.error(`❌ Failed to remove ${supplementName}:`, error);
    }
  }

  for (const supplementName of supplementsToAdd) {
    try {
      await globalAddSupplementToCart(
        supplementName,
        null,
        "Adding...",
        "Added to Stack",
        "AddToCartCheckoutSync",
        false // Don't open cart during checkout
      );
      console.log(`✅ Added ${supplementName} to cart`);
    } catch (error) {
      console.error(`❌ Failed to add ${supplementName}:`, error);
    }
  }
}

// Option A: Keep exactly the same API but run quantity updates in parallel
async function normalizeQuantities(cartItemsToUpdate) {
  if (!cartItemsToUpdate.length) return;

  await Promise.all(
    cartItemsToUpdate.map(async item => {
      try {
        const updateResponse = await fetch('/cart/change.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({
            id: item.key,
            quantity: item.targetQuantity
          })
        });

        if (!updateResponse.ok) {
          throw new Error(`Failed to update quantity: ${updateResponse.status}`);
        }

        await updateResponse.json();
        console.log(
          `✅ Updated ${item.supplementName} quantity from ${item.currentQuantity} to ${item.targetQuantity}`
        );
      } catch (error) {
        console.error(
          `❌ Failed to update quantity for ${item.supplementName}:`,
          error
        );
      }
    })
  );
}

// Add box then app, sequentially, same as before
async function addBoxAndAppToCart() {
  const quantity = 1;

  const formDataBox = new FormData();
  formDataBox.append('id', parseInt(BOX_VARIANT_ID, 10));
  formDataBox.append('quantity', quantity);
  formDataBox.append('properties[Contains]', '30 daily sachets');

  const formDataApp = new FormData();
  formDataApp.append('id', parseInt(APP_VARIANT_ID, 10));
  formDataApp.append('quantity', quantity);

  let boxAdded = false;
  let appAdded = false;

  try {
    const boxResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: formDataBox
    });

    if (!boxResponse.ok) {
      throw new Error(`Failed to add box: ${boxResponse.status}`);
    }

    const boxResult = await boxResponse.json();
    console.log('✅ Monthly Box added to cart:', boxResult);
    boxAdded = true;
  } catch (error) {
    console.error('❌ Error adding monthly box:', error);
    throw new Error('Failed to add monthly box to cart');
  }

  if (!boxAdded) {
    throw new Error('Monthly box could not be added to cart');
  }

  try {
    const appResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: formDataApp
    });

    if (!appResponse.ok) {
      throw new Error(`Failed to add app: ${appResponse.status}`);
    }

    const appResult = await appResponse.json();
    console.log('✅ App access added to cart:', appResult);
    appAdded = true;
  } catch (error) {
    console.error('❌ Error adding app access:', error);
    throw new Error('Failed to add app access to cart');
  }

  if (!boxAdded || !appAdded) {
    throw new Error('Could not add all required items to cart');
  }

  console.log('✅ Both box and app successfully added to cart, proceeding to checkout...');
}

async function addAppToCart() {
  const formDataApp = new FormData();
  formDataApp.append('id', parseInt(APP_VARIANT_ID, 10));
  formDataApp.append('quantity', 1);

  try {
    const appResponse = await fetch('/cart/add.js', {
      method: 'POST',
      body: formDataApp
    });

    if (!appResponse.ok) {
      throw new Error(`Failed to add app: ${appResponse.status}`);
    }

    const appResult = await appResponse.json();
    console.log('✅ App access added to cart:', appResult);
  } catch (error) {
    console.error('❌ Error adding app access:', error);
    throw new Error('Failed to add app access to cart');
  }
}

function redirectToCheckoutWithDiscounts(discountCodes) {
  if (discountCodes.length > 0) {
    const discountQuery = discountCodes
      .map(code => encodeURIComponent(code))
      .join(',');
    window.location.href = `/checkout?discount=${discountQuery}`;
  } else {
    window.location.href = '/checkout';
  }
}




// Global function to go to checkout (element-agnostic)
async function globalGoToCheckout(
  callbacks = {},
  buttonElement = null,
  processingText = "Redirecting..."
) {
  disableCheckout();

  const { onSuccess, onError } = callbacks;

  // Retry helper (only used for fetchShopifyCart)
  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  async function fetchShopifyCartWithRetry({
    attempts = 5,
    initialDelayMs = 250,
    backoffFactor = 2,
    jitterMs = 150,
    shouldRetry = (err) => {
      // Retry only on transient errors (500/502/503/504) or network failures
      const msg = String(err?.message || "");
      const match = msg.match(/Failed to fetch cart:\s*(\d+)/);
      const status = match ? Number(match[1]) : null;
      const transientStatuses = new Set([500, 502, 503, 504]);
      return status === null || transientStatuses.has(status);
    },
  } = {}) {
    let delay = initialDelayMs;

    for (let i = 1; i <= attempts; i++) {
      try {
        return await fetchShopifyCart();
      } catch (err) {
        const lastAttempt = i === attempts;

        if (!shouldRetry(err) || lastAttempt) {
          throw err;
        }

        const jitter = Math.floor(Math.random() * jitterMs);
        console.warn(
          `⚠️ fetchShopifyCart failed (attempt ${i}/${attempts}). Retrying in ${delay + jitter}ms...`,
          err
        );

        await sleep(delay + jitter);
        delay = Math.min(delay * backoffFactor, 3000); // cap delay
      }
    }
  }

  try {
    if (buttonElement) {
      buttonElement.innerHTML = processingText;
      buttonElement.disabled = true;
    }

    const currentSupplementCart = getCurrentSupplementCartFromLocalStorage();
    const supplements = Object.keys(currentSupplementCart);

    if (supplements.length === 0) {
      throw new Error("Cart is empty");
    }

    console.log("🔄 Syncing cart contents before checkout...");

    // Retry cart fetch (transient errors only)
    const currentCart = await fetchShopifyCartWithRetry({
      attempts: 6,
      initialDelayMs: 200,
      backoffFactor: 2,
      jitterMs: 200,
    });

    const { supplementsToRemove, supplementsToAdd, cartItemsToUpdate } =
      analyzeCart(currentCart, supplements);

    // 1. Sync cart contents to match currentSupplementCart
    await syncSupplementsWithCart({ supplementsToRemove, supplementsToAdd });
    await normalizeQuantities(cartItemsToUpdate);

    console.log("✅ Cart sync completed");

    // 2. Add Box and App to cart
    await addBoxAndAppToCart();

    // 3. Prepare discount and tags, then redirect
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts || {});

    // If callbacks.discountCode is provided (e.g. time-limited code from Big Floating CTA), append to URL when not already applied
    if (callbacks.discountCode && String(callbacks.discountCode).trim()) {
      const code = String(callbacks.discountCode).trim();
      const codeLower = code.toLowerCase();
      if (!discountCodes.some((c) => String(c).toLowerCase() === codeLower)) {
        discountCodes.push(code);
      }
    }

    try {
      console.log("📝 Adding initiated_checkout tag...");
      globalAddTags(["initiated_checkout"]);
    } catch (error) {
      console.warn(
        "⚠️ Failed to add initiated_checkout tag, continuing to checkout:",
        error
      );
    }

    try {
      // Track checkout intent based on subscription state
      if (window.isSubscription === true) {
        trackGoogle("initiated_checkout_subscribe_and_save");
      } else {
        trackGoogle("initiated_checkout_one_time_purchase");
      }
    } catch (error) {
      console.warn("⚠️ Failed to track Google checkout event:", error);
    }

    if (typeof onSuccess === "function") onSuccess();

    enableCheckout();
    redirectToCheckoutWithDiscounts(discountCodes);

    return {
      success: true,
      message: "Redirecting to checkout...",
      discountCodes,
    };
  } catch (error) {
    console.error("❌ Error during checkout:", error);

    if (buttonElement) {
      buttonElement.innerHTML = "Checkout";
      buttonElement.disabled = false;
    }

    enableCheckout();

    if (typeof onError === "function") onError(error);

    return {
      success: false,
      message: error.message || "Failed to process checkout",
      error,
    };
  }
}



async function globalGoToCheckoutProtocol(
  callbacks = {},
  buttonElement = null,
  processingText = "Redirecting..."
) {
  disableCheckout();

  const { onSuccess, onError } = callbacks;

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  async function fetchShopifyCartWithRetry({
    attempts = 5,
    initialDelayMs = 250,
    backoffFactor = 2,
    jitterMs = 150,
    shouldRetry = (err) => {
      const msg = String(err?.message || "");
      const match = msg.match(/Failed to fetch cart:\s*(\d+)/);
      const status = match ? Number(match[1]) : null;
      const transientStatuses = new Set([500, 502, 503, 504]);
      return status === null || transientStatuses.has(status);
    },
  } = {}) {
    let delay = initialDelayMs;

    for (let i = 1; i <= attempts; i++) {
      try {
        return await fetchShopifyCart();
      } catch (err) {
        const lastAttempt = i === attempts;

        if (!shouldRetry(err) || lastAttempt) {
          throw err;
        }

        const jitter = Math.floor(Math.random() * jitterMs);
        console.warn(
          `⚠️ fetchShopifyCart failed (attempt ${i}/${attempts}). Retrying in ${delay + jitter}ms...`,
          err
        );

        await sleep(delay + jitter);
        delay = Math.min(delay * backoffFactor, 3000);
      }
    }
  }

  try {
    if (buttonElement) {
      buttonElement.innerHTML = processingText;
      buttonElement.disabled = true;
    }

    // When requested (recommendation-page checkout buttons), run the full
    // plan-page cart sync first so app + sachet line(s) per plan_type + plan
    // line are all correct before checkout. Other callers keep the lighter
    // protocol-only sync below.
    if (callbacks.useFullSync && typeof syncPlanPageCart === 'function') {
      await syncPlanPageCart();
    }

    const plan = window.currentProtocol && window.currentProtocol.plan;
    if (!plan) {
      throw new Error("No protocol plan selected");
    }

    const protocolData = NutricodeProtocol[plan];
    if (!protocolData) {
      throw new Error(`No protocol data found for plan "${plan}"`);
    }

    if (!callbacks.useFullSync) {
    const expectedVariantId = String(protocolData.variant_id);
    const expectedSellingPlan = protocolData.selling_plan_id;
    const startProtocol = formatStartProtocolForCartProperty(
      window.currentProtocol && window.currentProtocol.start_protocol
    );
    const protocolLineProperties = buildNutricodeProtocolLineProperties(plan, startProtocol);

    console.log("🔄 Syncing protocol cart before checkout...", { plan, expectedVariantId, startProtocol });

    const currentCart = await fetchShopifyCartWithRetry({
      attempts: 6,
      initialDelayMs: 200,
      backoffFactor: 2,
      jitterMs: 200,
    });

    // --- 1. Sync protocol item in cart
    const protocolVariantIds = new Set(
      Object.values(NutricodeProtocol).map(p => String(p.variant_id))
    );

    const protocolItemsInCart = currentCart.items.filter(
      item => protocolVariantIds.has(String(item.variant_id))
    );

    const correctItem = protocolItemsInCart.find(
      item => String(item.variant_id) === expectedVariantId
    );
    const wrongItems = protocolItemsInCart.filter(
      item => String(item.variant_id) !== expectedVariantId
    );

    // Remove wrong protocol variants
    for (const item of wrongItems) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: item.key, quantity: 0 })
        });
        console.log(`✅ Removed wrong protocol variant ${item.variant_id} from cart`);
      } catch (err) {
        console.error(`❌ Failed to remove wrong protocol variant ${item.variant_id}:`, err);
      }
    }

    if (correctItem) {
      const propsMatch = Object.keys(protocolLineProperties).every(
        (k) => String(cartLineProperty(correctItem, k) ?? '') === String(protocolLineProperties[k] ?? '')
      );
      if (correctItem.quantity !== 1 || !propsMatch) {
        try {
          await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              id: correctItem.key,
              quantity: 1,
              properties: protocolLineProperties
            })
          });
          console.log(`✅ Updated protocol line (quantity / properties)`);
        } catch (err) {
          console.error('❌ Failed to update protocol line:', err);
        }
      }
    } else {
      // Protocol not in cart at all — add it
      try {
        await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: parseInt(expectedVariantId, 10),
            quantity: 1,
            selling_plan: expectedSellingPlan,
            properties: protocolLineProperties
          })
        });
        console.log('✅ Added missing protocol to cart');
      } catch (err) {
        console.error('❌ Failed to add protocol to cart:', err);
        throw new Error('Failed to add protocol to cart');
      }
    }

    console.log("✅ Protocol cart sync completed");
    }

    // --- 3. Prepare discount and tags, then redirect
    const appliedDiscounts = getAppliedDiscounts();
    const discountCodes = Object.keys(appliedDiscounts || {});

    if (Array.isArray(callbacks.discountCodes) && callbacks.discountCodes.length) {
      callbacks.discountCodes.forEach(function (code) {
        var trimmed = String(code || '').trim();
        if (!trimmed) return;
        var codeLower = trimmed.toLowerCase();
        if (!discountCodes.some(function (c) {
          return String(c).toLowerCase() === codeLower;
        })) {
          discountCodes.push(trimmed);
        }
      });
    } else if (callbacks.discountCode && String(callbacks.discountCode).trim()) {
      const code = String(callbacks.discountCode).trim();
      const codeLower = code.toLowerCase();
      if (!discountCodes.some((c) => String(c).toLowerCase() === codeLower)) {
        discountCodes.push(code);
      }
    }

    // Plan-specific checkout tag
    const planTagMap = {
      'month': 'initiated_checkout_month',
      '2-month': 'initiated_checkout_2month',
      '3-month': 'initiated_checkout_3month'
    };
    const checkoutTag = planTagMap[plan] || 'initiated_checkout_protocol';

    try {
      console.log(`📝 Adding ${checkoutTag} tag...`);
      globalAddTags([checkoutTag, 'initiated_checkout']);
    } catch (error) {
      console.warn("⚠️ Failed to add checkout tag, continuing:", error);
    }

    try {
      trackGoogle(checkoutTag);
    } catch (error) {
      console.warn("⚠️ Failed to track Google checkout event:", error);
    }

    if (typeof onSuccess === "function") onSuccess();

    enableCheckout();
    redirectToCheckoutWithDiscounts(discountCodes);

    return {
      success: true,
      message: "Redirecting to checkout...",
      discountCodes,
    };
  } catch (error) {
    console.error("❌ Error during protocol checkout:", error);

    if (buttonElement) {
      buttonElement.innerHTML = "Checkout";
      buttonElement.disabled = false;
    }

    enableCheckout();

    if (typeof onError === "function") onError(error);

    return {
      success: false,
      message: error.message || "Failed to process checkout",
      error,
    };
  }
}







// Backward compatibility functions - these call the UI-specific functions
function openCart() {
  console.log('global open cart')
  // This function should be defined in cart-drawer-personal.js
  if (typeof window.openCart !== 'undefined') {
    return window.openCart();
  }
  console.warn('openCart function not found - make sure cart-drawer-personal.js is loaded');
}
  

function closeCart() {
  // This function should be defined in cart-drawer-personal.js
  if (typeof window.closeCart !== 'undefined') {
    return window.closeCart();
  }
  console.warn('closeCart function not found - make sure cart-drawer-personal.js is loaded');
}

function openCartProtocol() {
  console.log('global open cart protocol');
  if (typeof window.openCartProtocol !== 'undefined') {
    return window.openCartProtocol();
  }
  console.warn('openCartProtocol function not found');
}

function closeCartProtocol() {
  // This function should be defined in cart-drawer-personal.js
  if (typeof window.closeCartProtocol !== 'undefined') {
    return window.closeCartProtocol();
  }
  console.warn('closeCart function not found - make sure cart-drawer-personal.js is loaded');
}


// Backward compatibility - UI functions should be in cart-drawer-personal.js
function updateCartDrawerContent() {
  console.warn('updateCartDrawerContent should be called from cart-drawer-personal.js');
}

// Backward compatibility - UI functions should be in cart-drawer-personal.js
function updateCartSummary() {
  console.warn('updateCartSummary should be called from cart-drawer-personal.js');
}

// Backward compatibility - UI functions should be in cart-drawer-personal.js
function updateShippingProgress() {
  console.warn('updateShippingProgress should be called from cart-drawer-personal.js');
}

// Backward compatibility - UI functions should be in cart-drawer-personal.js
function checkAndDisplayAppliedDiscounts() {
  console.warn('checkAndDisplayAppliedDiscounts should be called from cart-drawer-personal.js');
}

function applyCartDiscount() {
  console.warn('applyCartDiscount should be called from cart-drawer-personal.js');
}

function showDiscountError() {
  console.warn('showDiscountError should be called from cart-drawer-personal.js');
}

function showDiscountSuccess() {
  console.warn('showDiscountSuccess should be called from cart-drawer-personal.js');
}

function displayAppliedDiscountsFromStorage() {
  console.warn('displayAppliedDiscountsFromStorage should be called from cart-drawer-personal.js');
}

function updateAppliedDiscounts() {
  console.warn('updateAppliedDiscounts should be called from cart-drawer-personal.js');
}

function refreshCartDrawer() {
  console.warn('refreshCartDrawer should be called from cart-drawer-personal.js');
}

function resetDiscountButton() {
  console.warn('resetDiscountButton should be called from cart-drawer-personal.js');
}

function removeAppliedDiscount() {
  console.warn('removeAppliedDiscount should be called from cart-drawer-personal.js');
}

function goToCheckout() {
  console.warn('goToCheckout should be called from cart-drawer-personal.js');
}

// Backward compatibility for addDiscount
function addDiscount(discountCode, buttonElement, CheckingText, AppliedText, InvalidText, AlreadyAppliedText) {
  return globalAddDiscount(discountCode, buttonElement, CheckingText, AppliedText, InvalidText, AlreadyAppliedText);
}

// Helper function to format price (keeping for backward compatibility)
function formatPrice(price, currencyCode = 'SGD') {
  const currencySymbols = {
    'SGD': 'S$',
    'USD': '$',
    'EUR': '€',
    'GBP': '£'
  };
  
  const symbol = currencySymbols[currencyCode] || currencyCode;
  return `${symbol} ${price.toFixed(2)}`;
}

// Enhanced formatting function from pre-checkout script
function formatWithCurrency(currencyInfo, amount) {
  let currencyCode = 'SGD';
  if (currencyInfo && currencyInfo.active) {
    currencyCode = currencyInfo.active;
  }
  
  // Special handling for IDR currency
  if (currencyCode === 'IDR') {
    const numericAmount = parseFloat(amount);
    if (isNaN(numericAmount)) return 'Rp0';
    
    // Convert to thousands and format with commas
    const amountInK = numericAmount / 1000;
    const formattedAmount = amountInK.toLocaleString('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
    
    return `Rp${formattedAmount}k`;
  }
  
  const currencyFormats = {
    USD: "${{amount}}",
    EUR: "€{{amount}}",
    GBP: "£{{amount}}",
    SGD: "${{amount}}",
    AUD: "${{amount}}",
    CAD: "${{amount}}",
    JPY: "¥{{amount}}",
    INR: "₹{{amount}}",
    CNY: "¥{{amount}}",
    HKD: "${{amount}}",
    MYR: "RM{{amount}}",
    IDR: "Rp{{amount}}",
    DEFAULT: "{{amount}} " + currencyCode
  };
  const formatTemplate = currencyFormats[currencyCode] || currencyFormats.DEFAULT;
  return formatTemplate.replace('{{amount}}', amount);
}




function getFormattedPrice(productName, isBox = false, currencyCode = 'SGD') {
  let price = 0;
  
  // Get price from the appropriate dictionary (matching product-header logic)
  if (isBox) {
    // Handle box products
    if (typeof priceBoxes !== 'undefined' && priceBoxes[productName]) {
      price = priceBoxes[productName].DEFAULT; // Default fallback
      if (priceBoxes[productName][currencyCode]) {
        price = priceBoxes[productName][currencyCode];
      }
    }
  } else {
    // Handle supplement products
    if (typeof priceSupplementsConverted !== 'undefined' && priceSupplementsConverted[productName]) {
      price = priceSupplementsConverted[productName].DEFAULT; // Default fallback
      if (priceSupplementsConverted[productName][currencyCode]) {
        price = priceSupplementsConverted[productName][currencyCode];
      }
    }
  }
  
  // Format currency prefix and price (matching product-header logic)
  let currencyPrefix = '$';
  let priceValue = price;
  let centsSuffix = '';
  
  switch (currencyCode) {
    case 'SGD':
      currencyPrefix = '$';
      break;
    case 'AUD':
      currencyPrefix = '$';
      break;
    case 'HKD':
      currencyPrefix = '$';
      break;
    case 'MYR':
      currencyPrefix = 'RM';
      break;
    case 'IDR':
      currencyPrefix = 'Rp';
      priceValue = Math.floor(price / 1000);
      centsSuffix = 'k';
      break;
    default: // SGD and others
      currencyPrefix = 'S$';
      break;
  }
  
  return { prefix: currencyPrefix, value: priceValue, suffix: centsSuffix };
}

// Calculate shipping cost using pre-checkout logic
function calculateShippingCost(totalPrice, currencyCode) {
  const shippingConfig = {
    SGD: { threshold: 50, cost: 5.5 },
    USD: { threshold: 40, cost: 4.0 },
    EUR: { threshold: 45, cost: 4.5 },
    MYR: { threshold: 215, cost: 29 },
    GBP: { threshold: 35, cost: 3.5 },
    AUD: { threshold: 75, cost: 9.9 },
    CAD: { threshold: 55, cost: 5.5 },
    JPY: { threshold: 5000, cost: 500 },
    INR: { threshold: 3000, cost: 300 },
    CNY: { threshold: 300, cost: 30 },
    HKD: { threshold: 400, cost: 99 },
    IDR: { threshold: 1100000, cost: 299000 },
    DEFAULT: { threshold: 50, cost: 5.5 }
  };
  
  const config = shippingConfig[currencyCode] || shippingConfig.DEFAULT;
  return totalPrice >= config.threshold ? 0 : config.cost;
}


/** Resolved email for Mailchimp API calls: optional override beats localStorage (emailMailchimp, then customerEmail). */
function getEmailForMailchimpApi(emailOverride) {
  if (emailOverride != null && typeof emailOverride === 'string' && emailOverride.trim() !== '') {
    return emailOverride.trim();
  }
  const customerEmail = localStorage.getItem('customerEmail');
  const emailMailchimp = localStorage.getItem('emailMailchimp');
  var e = (emailMailchimp || customerEmail || '').trim();
  return e || null;
}

// Global function to add tags to customer in backend (Shopify + Mailchimp)
// Second argument: optional email string (used for URL instead of localStorage when non-empty).
async function globalAddTags(tagsArray, emailOverride) {
    try {
      // Validate input
      if (!Array.isArray(tagsArray) || tagsArray.length === 0) {
        console.warn('⚠️ globalAddTags: No tags provided or invalid input');
        return {
          success: false,
          message: 'No tags provided or invalid input'
        };
      }
      
      const email = getEmailForMailchimpApi(emailOverride);
      if (!email) {
        console.warn('⚠️ globalAddTags: No customer email (pass as 2nd arg or set localStorage)');
        return {
          success: false,
          message: 'No customer email found'
        };
      }
      
      console.log(`📝 Adding tags to customer ${email}:`, tagsArray);

      // Get current currency and price
      let currencyCode = 'SGD';
      if (window.Shopify && Shopify.currency && Shopify.currency.active) {
        currencyCode = Shopify.currency.active;
      }
      
      // Prepare Mailchimp URL and request body
      const mailchimp_url = `https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/webhookMailchimpAddTags/${email}/${encodeURIComponent(currencyCode)}`;
      
      const tags_to_add = { tags: tagsArray };
      const json_tags = JSON.stringify(tags_to_add);
      
      // Retry logic configuration
      const maxAttempts = 10;
      const retryDelay = 2000;
      
      // Function to make API call with retry logic
      async function makeApiCall(url, name, method = 'POST') {
        let success = false;
        let attemptCount = 0;
        let lastError = null;
        
        while (!success && attemptCount < maxAttempts) {
          try {
            const response = await fetch(url, {
              method: method,
              headers: {
                'Content-Type': 'application/json',
              },
              body: method === 'POST' ? json_tags : undefined,
            });
            
            if (!response.ok) {
              throw new Error(`HTTP error! status: ${response.status}`);
            }
            
            const json = await response.json();
            console.log(`✅ ${name} tags updated successfully:`, json);
            success = true;
            
            return {
              success: true,
              message: `${name} tags added successfully`,
              data: json,
              tags: tagsArray
            };
            
          } catch (error) {
            console.error(`❌ Error adding ${name} tags (attempt ${attemptCount + 1}/${maxAttempts}):`, error);
            lastError = error;
            attemptCount++;
            
            if (attemptCount < maxAttempts) {
              console.log(`🔄 Retrying ${name} in ${retryDelay / 1000} seconds... (Attempt ${attemptCount}/${maxAttempts})`);
              await new Promise(resolve => setTimeout(resolve, retryDelay));
            }
          }
        }
        
        // If we've exhausted all attempts
        console.error(`❌ Failed to add ${name} tags after ${maxAttempts} attempts`);
        return {
          success: false,
          message: `Failed to add ${name} tags after ${maxAttempts} attempts`,
          error: lastError,
          tags: tagsArray
        };
      }
      
      // Call Mailchimp API
      console.log('🚀 Calling Mailchimp API...');
      
      const mailchimpResult = await makeApiCall(mailchimp_url, 'Mailchimp');
      
      // Log results
      console.log('📊 Mailchimp API Result:');
      console.log(`   Mailchimp: ${mailchimpResult.success ? '✅ Success' : '❌ Failed'}`);
      
      // Prepare response
      const response = {
        success: mailchimpResult.success,
        message: mailchimpResult.success 
          ? 'Tags added successfully to Mailchimp'
          : 'Failed to add tags to Mailchimp',
        tags: tagsArray,
        results: {
          mailchimp: mailchimpResult
        }
      };
      
      if (mailchimpResult.success) {
        console.log('🎉 globalAddTags completed successfully:', response.message);
      } else {
        console.error('❌ globalAddTags failed');
      }
      
      return response;
      
    } catch (error) {
      console.error('❌ Error in globalAddTags:', error);
      return {
        success: false,
        message: error.message || 'Failed to add tags',
        error: error,
        tags: tagsArray
      };
    }
  }


/**
 * Set Mailchimp merge fields: POST body is merge-tag dict (e.g. FNAME). Email in URL path.
 * Second argument: optional email (used instead of localStorage when non-empty).
 */
async function globalAddMailchimpParam(dict, emailOverride) {
  try {
    if (dict == null || typeof dict !== 'object' || Array.isArray(dict)) {
      console.warn('⚠️ globalAddMailchimpParam: invalid dict');
      return {
        success: false,
        message: 'Invalid merge field object'
      };
    }
    const keys = Object.keys(dict);
    if (keys.length === 0) {
      console.warn('⚠️ globalAddMailchimpParam: empty dict');
      return {
        success: false,
        message: 'No merge fields provided'
      };
    }

    const email = getEmailForMailchimpApi(emailOverride);
    if (!email) {
      console.warn('⚠️ globalAddMailchimpParam: No customer email (pass as 2nd arg or set localStorage)');
      return {
        success: false,
        message: 'No customer email found'
      };
    }

    const url =
      'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/MAILCHIMP_addMergeTags/' +
      email;
    const body = JSON.stringify(dict);

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: body
    });

    if (!response.ok) {
      const text = await response.text().catch(function () {
        return '';
      });
      console.error('❌ globalAddMailchimpParam HTTP error', response.status, text);
      return {
        success: false,
        message: 'HTTP ' + response.status,
        details: text
      };
    }

    var data = {};
    try {
      data = await response.json();
    } catch (e) {
      /* non-JSON body */
    }

    console.log('✅ globalAddMailchimpParam:', data);
    return {
      success: true,
      message: 'Merge fields sent',
      data: data
    };
  } catch (error) {
    console.error('❌ Error in globalAddMailchimpParam:', error);
    return {
      success: false,
      message: error.message || 'Failed to update merge fields',
      error: error
    };
  }
}


// Global function to update customer's last_cart metafield
// Sends window.currentSupplementCart as-is to your backend
async function globalUpdateCartMetafield() {
  try {
    const customerEmail = localStorage.getItem('customerEmail');
    const emailMailchimp = localStorage.getItem('emailMailchimp');
        const email = emailMailchimp || customerEmail;

    if (!email) {
      console.warn('⚠️ globalUpdateCartMetafield: No customer email found in localStorage, skipping metafield update');
      return {
        success: false,
        message: 'No customer email found in localStorage'
      };
    }

    // Use the in-memory cart object; fall back to localStorage if needed
    let cartPayload = window.currentSupplementCart;
    if (!cartPayload || typeof cartPayload !== 'object') {
      try {
        const stored = localStorage.getItem('currentSupplementCart');
        cartPayload = stored ? JSON.parse(stored) : {};
      } catch (e) {
        console.warn('⚠️ Could not parse currentSupplementCart from localStorage, using empty object', e);
        cartPayload = {};
      }
    }

    console.log('📝 Updating last_cart metafield for', email, 'with:', cartPayload);

    const url = `https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_updateCartMetafield/${encodeURIComponent(email)}`;

    const response = await fetch(url, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        cart: cartPayload
      })
    });

    if (!response.ok) {
      const text = await response.text().catch(() => '');
      console.error('❌ globalUpdateCartMetafield: backend returned error', response.status, text);
      return {
        success: false,
        message: `Backend error: ${response.status}`,
        details: text
      };
    }

    const json = await response.json().catch(() => ({}));
    console.log('✅ last_cart metafield updated successfully:', json);

    return {
      success: true,
      message: 'last_cart metafield updated',
      data: json
    };

  } catch (error) {
    console.error('❌ Error in globalUpdateCartMetafield:', error);
    return {
      success: false,
      message: error.message || 'Failed to update last_cart metafield',
      error
    };
  }
}


// Helper: save window.currentSupplementCart to localStorage AND backend metafield
async function saveCurrentSupplementCart() {
  try {
    const serialized = JSON.stringify(window.currentSupplementCart || {});
    // localStorage.setItem is technically synchronous, but we keep await to match existing style
    localStorage.setItem("currentSupplementCart", serialized);
  } catch (e) {
    console.warn('⚠️ Failed to save currentSupplementCart to localStorage:', e);
  }

  try {
    await globalUpdateCartMetafield();
  } catch (e) {
    console.warn('⚠️ Failed to update last_cart metafield (non-blocking):', e);
  }
}

/**
 * Persists arbitrary data for a Shopify customer via Cloud Function (Firebase-backed).
 * @param {string} email
 * @param {string} endpoint - Logical route key for the backend handler
 * @param {object} data - Payload (e.g. { supplements: string[] })
 */
async function saveFirebase(email, endpoint, data) {
  const url =
    'https://us-central1-nutricodeapp-3da5f.cloudfunctions.net/SHOPIFY_saveFirebase';

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({
      email: email,
      endpoint: endpoint,
      data: data
    })
  });

  const text = await response.text().catch(() => '');
  let json = null;
  try {
    json = text ? JSON.parse(text) : {};
  } catch (e) {
    if (!response.ok) {
      throw new Error(text || `HTTP ${response.status}`);
    }
    json = { raw: text };
  }

  if (!response.ok) {
    throw new Error(json.message || json.error || text || `HTTP ${response.status}`);
  }

  return json;
}


async function globalAddProtocolToCart(
  plan,
  eventName = 'AddProtocolToCart_',
  shouldOpenCart = true
) {
  disableCheckout();

  try {
    const protocolData = NutricodeProtocol[plan];
    if (!protocolData) throw new Error(`No protocol data found for plan "${plan}"`);

    const { variant_id: variantId, selling_plan_id: sellingPlanId } = protocolData;

    const startProtocol = formatStartProtocolForCartProperty(
      window.currentProtocol && window.currentProtocol.start_protocol
    );
    const protocolLineProperties = buildNutricodeProtocolLineProperties(plan, startProtocol);

    // Ensure only one Nutricode protocol is in the cart: replace existing if different
    let protocolItemResult = null;
    try {
      const cartResponse = typeof fetchShopifyCart === 'function'
        ? await fetchShopifyCart()
        : await (await fetch('/cart.js', { headers: { 'Accept': 'application/json' } })).json();

      const protocolVariantIds = new Set(
        Object.values(NutricodeProtocol || {}).map(p => String(p.variant_id))
      );

      const currentProtocolItem = cartResponse.items.find(item =>
        protocolVariantIds.has(String(item.variant_id))
      );

      if (currentProtocolItem) {
        // If the same variant is already present, just normalize quantity/properties
        if (String(currentProtocolItem.variant_id) === String(variantId)) {
          const changePayload = {
            id: currentProtocolItem.key,
            quantity: 1,
            properties: protocolLineProperties
          };

          const changeResp = await fetch('/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(changePayload)
          });
          if (!changeResp.ok) throw new Error(`HTTP error! status: ${changeResp.status}`);
          protocolItemResult = await changeResp.json();
        } else {
          // Remove existing protocol item then add the new one
          try {
            await fetch('/cart/change.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ id: currentProtocolItem.key, quantity: 0 })
            });
          } catch (removeErr) {
            console.warn('globalAddProtocolToCart: failed to remove existing protocol item', removeErr);
          }

          const addPayload = {
            id: variantId,
            quantity: 1,
            selling_plan: sellingPlanId,
            properties: protocolLineProperties
          };

          const addResp = await fetch("/cart/add.js", {
            method: "POST",
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(addPayload),
          });
          if (!addResp.ok) throw new Error(`HTTP error! status: ${addResp.status}`);
          protocolItemResult = await addResp.json();
        }
      } else {
        // No existing protocol item: simple add
        const addPayload = {
          id: variantId,
          quantity: 1,
          selling_plan: sellingPlanId,
          properties: protocolLineProperties
        };

        const addResp = await fetch("/cart/add.js", {
          method: "POST",
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(addPayload),
        });
        if (!addResp.ok) throw new Error(`HTTP error! status: ${addResp.status}`);
        protocolItemResult = await addResp.json();
      }
    } catch (cartErr) {
      console.error('globalAddProtocolToCart: failed to sync existing protocol item, falling back to simple add', cartErr);

      const fallbackPayload = {
        id: variantId,
        quantity: 1,
        selling_plan: sellingPlanId,
        properties: protocolLineProperties
      };

      const fallbackResp = await fetch("/cart/add.js", {
        method: "POST",
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(fallbackPayload),
      });
      if (!fallbackResp.ok) throw new Error(`HTTP error! status: ${fallbackResp.status}`);
      protocolItemResult = await fallbackResp.json();
    }

    console.log("✅ Protocol added/updated in cart:", protocolItemResult);

    if (shouldOpenCart) {
      openCartProtocol(true);
    }

    window.currentProtocol.plan = plan;
    try { localStorage.setItem('currentProtocol', JSON.stringify(window.currentProtocol)); } catch (e) {}

    window.dispatchEvent(new CustomEvent('protocolChanged', {
      detail: {
        eventName: eventName,
        plan: plan,
        startProtocol: startProtocol,
        action: 'addProtocol',
        functionName: 'globalAddProtocolToCart'
      }
    }));

    setTimeout(() => {
      window.dispatchEvent(new CustomEvent('protocolChangedDelayed', {
        detail: {
          eventName: eventName,
          plan: plan,
          startProtocol: startProtocol,
          action: 'addProtocol',
          functionName: 'globalAddProtocolToCart'
        }
      }));
    }, 1000);

    let currencyCode = "SGD";
    if (window.Shopify?.currency?.active) {
      currencyCode = Shopify.currency.active;
    }

    const planPrices = priceProtocolConverted[plan];
    const price = (planPrices && planPrices[currencyCode]) || (planPrices && planPrices.DEFAULT) || 0;

    trackGoogle(eventName, {
      content_type: "product",
      content_ids: [String(variantId)],
      contents: [
        {
          id: String(variantId),
          quantity: 1,
          item_price: price,
        },
      ],
      value: price,
      currency: currencyCode,
      product_title: `Nutricode Protocol ${plan}`,
    });

    if (!sessionStorage.getItem('uniqueAddToCartTracked')) {
      sessionStorage.setItem("uniqueAddToCartTracked", "true");
    }

    // --- 11. Update cart supplement tags based on current cart state
    // TODO: implement tag logic for protocols
    // try {
    //   ...
    // } catch (error) {
    //   console.warn('⚠️ Error updating cart supplement tags:', error);
    // }

    enableCheckout();

  } catch (error) {
    console.error("❌ Error adding protocol to cart:", error);
    enableCheckout();
    return null;
  }
}

/**
 * Line-item value for _start_protocol: comma-separated supplements from currentProtocol.start_protocol.
 * Supports array (new), string (legacy), or other primitives.
 */
function formatStartProtocolForCartProperty(startProtocol) {
  if (startProtocol == null) return '';
  if (Array.isArray(startProtocol)) {
    return startProtocol.map((s) => String(s).trim()).filter(Boolean).join(',');
  }
  if (typeof startProtocol === 'string') return startProtocol;
  return String(startProtocol);
}

/**
 * Balanced morning/evening split used as a fallback when currentProtocol does
 * not carry explicit morning_protocol / evening_protocol lists.
 * Mirrors splitStartProtocolBalanced() in sections/header.liquid.
 */
function splitProtocolForSachets(startProtocol) {
  const arr = Array.isArray(startProtocol)
    ? startProtocol.filter((s) => String(s).trim())
    : [];
  if (!arr.length) return { morning: [], evening: [] };
  const splitAt = Math.ceil(arr.length / 2);
  return { morning: arr.slice(0, splitAt), evening: arr.slice(splitAt) };
}

/**
 * Resolve the morning/evening supplement lists for a protocol. Prefers explicit
 * morning_protocol / evening_protocol; falls back to a balanced split of
 * start_protocol so the value always stays aligned with what's in the cart.
 */
function resolveProtocolSachetLists(cp) {
  cp = cp || {};
  const morning = Array.isArray(cp.morning_protocol) ? cp.morning_protocol : null;
  const evening = Array.isArray(cp.evening_protocol) ? cp.evening_protocol : null;
  if ((morning && morning.length) || (evening && evening.length)) {
    return { morning: morning || [], evening: evening || [] };
  }
  return splitProtocolForSachets(cp.start_protocol);
}

/** Normalised plan_type ('practical' or 'optimised'); optimised is the default. */
function resolveProtocolPlanType(cp) {
  return cp && cp.plan_type === 'practical' ? 'practical' : 'optimised';
}

/**
 * Email from connect-device recommendation payload stored in localStorage (`info.email`).
 */
function getEmailFromRecommendationAnalysisStorage() {
  if (typeof localStorage === 'undefined') return '';
  try {
    const raw = localStorage.getItem('recommendationAnalysis');
    if (raw == null || !String(raw).trim()) return '';
    const parsed = JSON.parse(raw);
    if (parsed == null || typeof parsed !== 'object') return '';
    const info = parsed.info;
    if (info == null || typeof info !== 'object') return '';
    const email = info.email;
    if (email == null) return '';
    return String(email).trim();
  } catch (e) {
    return '';
  }
}

/**
 * Properties for Nutricode protocol subscription line items (_start_protocol, _plan, _email_recommendation from localStorage recommendationAnalysis.info.email, optional _quiz_result).
 */
function buildNutricodeProtocolLineProperties(planKey, startProtocolFormatted) {
  const cp = (typeof window !== 'undefined' && window.currentProtocol) || {};
  const sachets = resolveProtocolSachetLists(cp);
  const props = {
    _start_protocol: startProtocolFormatted,
    _plan: planKey,
    _plan_type: resolveProtocolPlanType(cp),
    _morning_protocol: formatStartProtocolForCartProperty(sachets.morning),
    _evening_protocol: formatStartProtocolForCartProperty(sachets.evening),
    _email_recommendation: getEmailFromRecommendationAnalysisStorage(),
  };
  const quiz = typeof window !== 'undefined' ? window.getStartedState : undefined;
  if (quiz != null && typeof quiz === 'object') {
    try {
      props._quiz_result = JSON.stringify(quiz);
    } catch (e) {
      console.warn('buildNutricodeProtocolLineProperties: failed to stringify getStartedState', e);
    }
  }
  return props;
}

function cartLineProperty(item, key) {
  const p = item && item.properties;
  if (p == null) return undefined;
  if (Array.isArray(p)) {
    const row = p.find((x) => (x && (x.name === key || x.key === key)));
    return row != null ? row.value : undefined;
  }
  return p[key];
}

/** Selling plan id applied to a cart line item, as a string ('' when none). */
function cartLineSellingPlanId(item) {
  const sp =
    item && item.selling_plan_allocation && item.selling_plan_allocation.selling_plan;
  return sp && sp.id != null ? String(sp.id) : '';
}

function startingProtocolContainsText(item) {
  const fromContains = cartLineProperty(item, STARTING_PROTOCOL_CONTAINS_PROPERTY);
  if (fromContains != null && String(fromContains) !== '') return String(fromContains);
  return String(cartLineProperty(item, '_start_protocol') ?? '');
}

/** Promise-based sleep used by the resilient cart helpers below. */
function syncCartSleep(ms) {
  return new Promise((resolve) => setTimeout(resolve, ms));
}

/**
 * Cart read with backoff retry on 429 (rate limit), transient 5xx and network
 * errors. Helps when Shopify's own listeners / chat widget are also hitting
 * /cart.js at the same time.
 */
async function fetchShopifyCartResilient({
  attempts = 5,
  initialDelayMs = 300,
  backoffFactor = 2,
  jitterMs = 200,
} = {}) {
  let delay = initialDelayMs;
  for (let i = 1; i <= attempts; i++) {
    try {
      return await fetchShopifyCart();
    } catch (err) {
      const m = String((err && err.message) || '').match(/Failed to fetch cart:\s*(\d+)/);
      const status = m ? Number(m[1]) : null;
      const retriable =
        status === null || status === 429 || status === 500 || status === 502 || status === 503 || status === 504;
      if (!retriable || i === attempts) throw err;
      await syncCartSleep(delay + Math.floor(Math.random() * jitterMs));
      delay = Math.min(delay * backoffFactor, 3000);
    }
  }
}

/**
 * POST JSON to a Shopify cart endpoint, retrying on 429 (honouring Retry-After).
 * Returns parsed JSON, or null on a non-JSON success. Throws on other failures.
 */
async function postCartJson(url, body, { attempts = 3, initialDelayMs = 300 } = {}) {
  let delay = initialDelayMs;
  for (let i = 1; i <= attempts; i++) {
    const res = await fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    });
    if (res.ok) {
      try {
        return await res.json();
      } catch (e) {
        return null;
      }
    }
    if (res.status === 429 && i < attempts) {
      const retryAfter = Number(res.headers.get('Retry-After'));
      const wait = Number.isFinite(retryAfter) && retryAfter > 0 ? retryAfter * 1000 : delay;
      await syncCartSleep(wait + Math.floor(Math.random() * 150));
      delay = Math.min(delay * 2, 3000);
      continue;
    }
    // Surface Shopify's reason (e.g. invalid selling plan / sold out) for 4xx.
    let detail = '';
    try {
      const j = await res.json();
      detail = j && (j.description || j.message) ? ' - ' + (j.description || j.message) : '';
    } catch (e) {}
    const err = new Error('HTTP error! status: ' + res.status + detail);
    err.status = res.status;
    throw err;
  }
}

/**
 * Sync cart for the plan page: only app, sachet line(s), and Nutricode protocol allowed.
 * Computes the desired end-state in memory from window.currentProtocol, then flushes it
 * in at most two cart writes (one batched /cart/update.js for removals + quantity fixes,
 * one batched /cart/add.js for missing lines) on top of a single resilient /cart.js read.
 * This keeps the number of cart API round-trips minimal to avoid 429 rate limiting.
 *
 * Sachet lines depend on plan_type: practical -> one DAILY_SACHETS line
 * (Contains = start_protocol); optimised -> MORNING_SACHETS (Contains = morning_protocol)
 * + EVENING_SACHETS (Contains = evening_protocol). The supplement list always rides on
 * properties[Contains]; the variant is a placeholder for the product.
 * Call once at plan page load.
 */
async function syncPlanPageCart() {
  if (typeof fetchShopifyCart !== 'function') {
    console.warn('syncPlanPageCart: fetchShopifyCart not available');
    return;
  }

  // Single (resilient) cart read; every mutation below is computed in memory.
  let cart;
  try {
    cart = await fetchShopifyCartResilient();
  } catch (err) {
    console.warn('syncPlanPageCart: failed to fetch cart', err);
    return;
  }
  if (!cart || !Array.isArray(cart.items)) return;

  if (!window.currentProtocol) window.currentProtocol = {};

  const appVariantIdStr = String(APP_VARIANT_ID);
  const protocolVariantIds =
    typeof NutricodeProtocol !== 'undefined'
      ? new Set(Object.values(NutricodeProtocol).map((p) => String(p.variant_id)))
      : new Set();

  // Ensure a plan key (default monthly); persist only if we had to set it.
  let planKey = window.currentProtocol.plan;
  if (!planKey || !protocolVariantIds.size) {
    planKey = 'month';
    window.currentProtocol.plan = planKey;
    try {
      localStorage.setItem('currentProtocol', JSON.stringify(window.currentProtocol));
    } catch (e) {}
  }

  const planLinePropertiesMatch = (item, expectedProps) =>
    Object.keys(expectedProps).every(
      (k) => String(cartLineProperty(item, k) ?? '') === String(expectedProps[k] ?? '')
    );

  // ── Build the desired set of lines. Each entry knows how to match an existing
  //    cart line and (if missing) how to add it. ─────────────────────────────
  const planType = resolveProtocolPlanType(window.currentProtocol);
  const sachetLists = resolveProtocolSachetLists(window.currentProtocol);
  const startText = formatStartProtocolForCartProperty(window.currentProtocol.start_protocol);
  const morningText = formatStartProtocolForCartProperty(sachetLists.morning);
  const eveningText = formatStartProtocolForCartProperty(sachetLists.evening);

  const defaultStartEntry =
    (typeof StartingProtocol !== 'undefined' &&
      StartingProtocol &&
      (StartingProtocol.fitness || Object.values(StartingProtocol)[0])) ||
    null;
  const defaultDailyVariantId = defaultStartEntry ? String(defaultStartEntry.variant_id) : null;

  const sachetDesired = (productId, variantId, containsText) => ({
    variantId: variantId != null ? String(variantId) : null,
    properties: { [STARTING_PROTOCOL_CONTAINS_PROPERTY]: containsText },
    match: (it) =>
      Number(it.product_id) === Number(productId) &&
      startingProtocolContainsText(it) === containsText,
  });

  // Build each line, then assemble the cart in the exact target order (reversed):
  //   1. Extra supplements
  //   2. Evening sachets  (optimised)
  //   3. Morning sachets  (optimised)
  //   4. Daily sachets    (practical)
  //   5. Box (Nutricode subscription / plan line)
  //   6. App access
  const appDesired = {
    variantId: appVariantIdStr,
    match: (it) => String(it.variant_id) === appVariantIdStr,
  };

  let dailyDesired = null;
  let morningDesired = null;
  let eveningDesired = null;
  if (planType === 'practical') {
    if (startText && defaultDailyVariantId) {
      dailyDesired = sachetDesired(DAILY_SACHETS_PRODUCT_ID, defaultDailyVariantId, startText);
    }
  } else {
    if (morningText) {
      morningDesired = sachetDesired(MORNING_SACHETS_PRODUCT_ID, MORNING_SACHETS_VARIANT_ID, morningText);
    }
    if (eveningText) {
      eveningDesired = sachetDesired(EVENING_SACHETS_PRODUCT_ID, EVENING_SACHETS_VARIANT_ID, eveningText);
    }
  }

  // Extra supplements: base sachet covers the first 4; each beyond is one unit
  // of the extra-supplement product, on its own selling plan.
  const protocolData = typeof NutricodeProtocol !== 'undefined' ? NutricodeProtocol[planKey] : null;
  const extraSellingPlan =
    typeof EXTRA_SUPPLEMENT_SELLING_PLAN_ID !== 'undefined' ? EXTRA_SUPPLEMENT_SELLING_PLAN_ID : null;
  const extraSellingPlanStr = extraSellingPlan != null ? String(extraSellingPlan) : '';
  const totalSupplementCount = Array.isArray(window.currentProtocol.start_protocol)
    ? window.currentProtocol.start_protocol.filter((s) => String(s).trim()).length
    : 0;
  const extraSupplementQty = Math.max(0, totalSupplementCount - PROTOCOL_BASE_SUPPLEMENT_COUNT);
  let extraDesired = null;
  if (extraSupplementQty > 0) {
    extraDesired = {
      variantId: String(EXTRA_SUPPLEMENT_VARIANT_ID),
      quantity: extraSupplementQty,
      sellingPlan: extraSellingPlan,
      match: (it) =>
        String(it.variant_id) === String(EXTRA_SUPPLEMENT_VARIANT_ID) &&
        cartLineSellingPlanId(it) === extraSellingPlanStr,
    };
  }

  // Box / Nutricode subscription plan line (only when a variant for the plan resolves).
  let planDesired = null;
  if (protocolData) {
    const expectedPlanProperties = buildNutricodeProtocolLineProperties(planKey, startText);
    planDesired = {
      variantId: String(protocolData.variant_id),
      sellingPlan: protocolData.selling_plan_id,
      properties: expectedPlanProperties,
      match: (it) =>
        String(it.variant_id) === String(protocolData.variant_id) &&
        planLinePropertiesMatch(it, expectedPlanProperties),
    };
  }

  // Desired cart, in display order (reversed; nulls skipped).
  const desired = [
    extraDesired,
    eveningDesired,
    morningDesired,
    dailyDesired,
    planDesired,
    appDesired,
  ].filter(Boolean);

  function desiredToCartItem(d) {
    const item = { id: parseInt(d.variantId, 10), quantity: d.quantity || 1 };
    if (d.properties) item.properties = d.properties;
    if (d.sellingPlan) item.selling_plan = d.sellingPlan;
    return item;
  }

  // Add desired entries (in order). One batched call; on an atomic 422 fall back
  // to per-item adds so one bad line can't block the rest of the cart.
  async function addDesired(list) {
    const items = list.filter((d) => d.variantId).map(desiredToCartItem);
    if (!items.length) return;
    try {
      await postCartJson('/cart/add.js', { items });
    } catch (e) {
      console.warn('syncPlanPageCart: batch add failed, retrying per-item', e);
      for (const item of items) {
        try {
          await postCartJson('/cart/add.js', { items: [item] });
        } catch (e2) {
          console.warn('syncPlanPageCart: failed to add line (variant ' + item.id + ')', e2);
        }
      }
    }
  }

  // Fast path: cart already matches desired exactly — same lines, same order,
  // same quantities — so there is nothing to do.
  const alreadyExact =
    cart.items.length === desired.length &&
    desired.every((d, i) => {
      const it = cart.items[i];
      return it && d.match(it) && it.quantity === (d.quantity || 1);
    });
  if (alreadyExact) return;

  if (planDesired) {
    // Enforce the exact line order. Shopify's AJAX cart has no reorder endpoint
    // (line order = add order), so when anything differs we clear and re-add in
    // order: one batched remove, then one batched add.
    const removeUpdates = {};
    for (const it of cart.items) removeUpdates[it.key] = 0;
    if (Object.keys(removeUpdates).length) {
      try {
        await postCartJson('/cart/update.js', { updates: removeUpdates });
      } catch (e) {
        console.warn('syncPlanPageCart: failed to clear cart before reorder', e);
      }
    }
    await addDesired(desired);
    return;
  }

  // Fallback (no resolvable plan): non-destructive incremental reconcile that
  // leaves any existing protocol-plan lines untouched.
  const updates = {};
  const keptKeys = new Set();
  const toAdd = [];
  for (const d of desired) {
    const wantQty = d.quantity || 1;
    const hit = cart.items.find((it) => !keptKeys.has(it.key) && d.match(it));
    if (hit) {
      keptKeys.add(hit.key);
      if (hit.quantity !== wantQty) updates[hit.key] = wantQty;
    } else {
      toAdd.push(d);
    }
  }
  for (const it of cart.items) {
    if (keptKeys.has(it.key)) continue;
    if (protocolVariantIds.has(String(it.variant_id))) continue;
    updates[it.key] = 0;
  }
  if (Object.keys(updates).length) {
    try {
      await postCartJson('/cart/update.js', { updates });
    } catch (e) {
      console.warn('syncPlanPageCart: failed to batch-update cart lines', e);
    }
  }
  await addDesired(toAdd);
}

// Add spinning animation for loading states
const spinningAnimationCSS = `
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
`;

// Inject CSS if it doesn't exist
if (!document.getElementById('cart-drawer-animations')) {
  const style = document.createElement('style');
  style.id = 'cart-drawer-animations';
  style.textContent = spinningAnimationCSS;
  document.head.appendChild(style);
}


/**
 * Sync Shopify cart to match currentSupplementCart (no checkout, no box/app).
 * Uses getCurrentSupplementCartFromLocalStorage, fetchShopifyCart, analyzeCart,
 * syncSupplementsWithCart, normalizeQuantities when available.
 */
async function globalSyncShopifyCartAndStorageCart() {
  const getCart = typeof getCurrentSupplementCartFromLocalStorage === 'function' ? getCurrentSupplementCartFromLocalStorage : null;
  const fetchCart = typeof fetchShopifyCart === 'function' ? fetchShopifyCart : null;
  const analyze = typeof analyzeCart === 'function' ? analyzeCart : null;
  const syncSupplements = typeof syncSupplementsWithCart === 'function' ? syncSupplementsWithCart : null;
  const normalize = typeof normalizeQuantities === 'function' ? normalizeQuantities : null;

  if (!getCart || !fetchCart || !analyze || !syncSupplements || !normalize) {
    console.warn('globalSyncShopifyCartAndStorageCart: missing helpers (getCurrentSupplementCartFromLocalStorage, fetchShopifyCart, analyzeCart, syncSupplementsWithCart, normalizeQuantities)');
    return { success: false, message: 'Missing cart helpers' };
  }

  const currentSupplementCart = getCart();
  const supplements = currentSupplementCart ? Object.keys(currentSupplementCart) : [];
  if (supplements.length === 0) {
    console.log('globalSyncShopifyCartAndStorageCart: Cart empty, nothing to sync');
    return { success: true, message: 'Cart empty' };
  }

  const sleep = (ms) => new Promise((r) => setTimeout(r, ms));
  const initialDelayMs = 250;
  const backoffFactor = 2;
  const jitterMs = 150;
  const attempts = 5;
  const shouldRetry = (err) => {
    const msg = String((err && err.message) || '');
    const match = msg.match(/Failed to fetch cart:\s*(\d+)/);
    const status = match ? Number(match[1]) : null;
    return status === null || [500, 502, 503, 504].indexOf(status) !== -1;
  };

  let delay = initialDelayMs;
  let currentCart = null;
  let lastErr = null;
  for (let i = 1; i <= attempts; i++) {
    try {
      currentCart = await fetchCart();
      lastErr = null;
      break;
    } catch (err) {
      lastErr = err;
      if (!shouldRetry(err) || i === attempts) {
        console.error('globalSyncShopifyCartAndStorageCart: fetch cart failed', err);
        return { success: false, message: err.message, error: err };
      }
      await sleep(delay + Math.floor(Math.random() * jitterMs));
      delay = Math.min(delay * backoffFactor, 3000);
    }
  }
  if (lastErr || !currentCart) {
    return { success: false, message: lastErr ? lastErr.message : 'No cart', error: lastErr };
  }

  const result = analyze(currentCart, supplements);
  const { supplementsToRemove, supplementsToAdd, cartItemsToUpdate } = result;

  await syncSupplementsWithCart({ supplementsToRemove, supplementsToAdd });
  await normalizeQuantities(cartItemsToUpdate);
  console.log('✅ globalSyncShopifyCartAndStorageCart completed');
  return { success: true };
}

/**
 * Recommendation page: paired CTAs (`a[data-protocol-checkout-cta]`) call
 * `globalGoToCheckoutProtocol` with shared loading UI (opacity + dot animation on active CTA).
 */
function initProtocolRecommendationCheckoutButtons() {
  var buttons = document.querySelectorAll('a[data-protocol-checkout-cta]');
  if (!buttons.length) return;

  var dotSequence = ['\u00B7', '\u00B7\u00B7', '\u00B7\u00B7\u00B7', ''];
  var dotIntervalMs = 400;

  function getAll() {
    return document.querySelectorAll('a[data-protocol-checkout-cta]');
  }

  function setPairOpacity(value) {
    getAll().forEach(function (b) {
      b.style.opacity = value;
    });
  }

  function setPairPointerEvents(value) {
    getAll().forEach(function (b) {
      b.style.pointerEvents = value;
    });
  }

  function cleanup(activeBtn) {
    if (activeBtn._protocolCheckoutDotTimer) {
      clearInterval(activeBtn._protocolCheckoutDotTimer);
      activeBtn._protocolCheckoutDotTimer = null;
    }
    var trail = activeBtn.querySelector('[data-protocol-cta-trail]');
    if (trail && activeBtn._protocolCheckoutTrailHtml != null) {
      trail.innerHTML = activeBtn._protocolCheckoutTrailHtml;
    }
    activeBtn._protocolCheckoutTrailHtml = null;
    setPairOpacity('');
    setPairPointerEvents('');
    getAll().forEach(function (b) {
      b.removeAttribute('aria-busy');
    });
  }

  buttons.forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      if (btn.getAttribute('aria-busy') === 'true') return;

      var trail = btn.querySelector('[data-protocol-cta-trail]');
      if (!trail) return;

      btn._protocolCheckoutTrailHtml = trail.innerHTML;
      trail.innerHTML =
        '<span class="protocol-checkout-dots" aria-hidden="true" style="display:inline-block;min-width:14px;text-align:left;font-size:12px;line-height:1"></span>';
      var dotsEl = trail.querySelector('.protocol-checkout-dots');
      var phase = 0;
      btn._protocolCheckoutDotTimer = setInterval(function () {
        dotsEl.textContent = dotSequence[phase % dotSequence.length];
        phase += 1;
      }, dotIntervalMs);

      btn.setAttribute('aria-busy', 'true');
      setPairOpacity('0.75');
      setPairPointerEvents('none');

      var checkoutDiscountCodes = [];
      if (typeof window.nutricodeGetProtocolCheckoutDiscountCodes === 'function') {
        checkoutDiscountCodes = window.nutricodeGetProtocolCheckoutDiscountCodes();
      } else {
        var checkoutDiscount =
          (typeof window.nutricodeGetProtocolCheckoutDiscountCode === 'function'
            ? window.nutricodeGetProtocolCheckoutDiscountCode()
            : btn.getAttribute('data-protocol-checkout-discount') ||
              (window.nutricodeCurrentOffer && window.nutricodeCurrentOffer.code) ||
              'GETSTARTED'
          ).trim();
        if (checkoutDiscount) {
          checkoutDiscountCodes = checkoutDiscount
            .split(',')
            .map(function (code) {
              return code.trim();
            })
            .filter(Boolean);
        }
      }

      globalGoToCheckoutProtocol(
        {
          discountCodes: checkoutDiscountCodes,
          useFullSync: true,
          onError: function () {
            cleanup(btn);
          },
        },
        null
      ).then(function (res) {
        if (res && res.success === false) {
          cleanup(btn);
        }
      });
    });
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initProtocolRecommendationCheckoutButtons);
} else {
  initProtocolRecommendationCheckoutButtons();
}